var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductInsigts = function SvgProductInsigts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.652 223.891"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "product_insigts_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h165.254v102.731H0z",
    "data-name": "Rectangle 3129"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_insigts_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h4.459v9.166H0z",
    "data-name": "Rectangle 3068"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_insigts_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h4.652v5.588H0z",
    "data-name": "Rectangle 3077"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_insigts_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h9.036v4.606H0z",
    "data-name": "Rectangle 3078"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_insigts_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.622v5.934H0z",
    "data-name": "Rectangle 3100"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_insigts_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.622v13.492H0z",
    "data-name": "Rectangle 3103"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_insigts_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.622v16.319H0z",
    "data-name": "Rectangle 3106"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_insigts_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.622v19.542H0z",
    "data-name": "Rectangle 3112"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_insigts_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.622v8.563H0z",
    "data-name": "Rectangle 3115"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_insigts_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h5.254v11.705H0z",
    "data-name": "Rectangle 3123"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "product_insigts_svg__a",
    width: 229.652,
    height: 223.891,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.173
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10040"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    className: "product_insigts_svg__svg-stoke",
    "data-name": "Path 16565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.857 189.527a81.6 81.6 0 0 1-16.318-1.644 80.6 80.6 0 0 1-15.198-4.718 81 81 0 0 1-13.753-7.465 81.6 81.6 0 0 1-11.983-9.887 81.6 81.6 0 0 1-9.887-11.983 81 81 0 0 1-7.465-13.753 80.6 80.6 0 0 1-4.717-15.197 81.6 81.6 0 0 1-1.645-16.318c0-8.606 2.396-19.11 6.93-30.377 4.563-11.341 10.982-22.675 18.564-32.774 3.967-5.284 8.198-10.152 12.577-14.47 4.607-4.542 9.382-8.478 14.193-11.697 5.09-3.406 10.26-6.036 15.367-7.816 5.415-1.888 10.833-2.845 16.106-2.845 12.936 0 25.177 5.682 36.384 16.889 12.652 12.652 22.266 23.309 29.392 32.58 3.542 4.607 6.481 8.872 8.988 13.039 2.423 4.03 4.38 7.866 5.983 11.73 6.247 15.06 6.116 28.466 5.936 47.02-.033 3.318-.066 6.748-.066 10.405 0 20.227-9.08 33.736-27.76 41.3-7.742 3.134-17.116 5.271-28.657 6.533-9.037.988-19.514 1.448-32.971 1.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M104.628 9.083c-5.216 0-10.58.948-15.942 2.817-5.067 1.766-10.199 4.377-15.253 7.76-4.785 3.201-9.535 7.117-14.12 11.638-4.361 4.3-8.576 9.15-12.528 14.413-7.556 10.065-13.953 21.36-18.5 32.66-2.22 5.516-3.938 10.893-5.107 15.982-1.186 5.16-1.787 9.941-1.787 14.209 0 5.46.55 10.917 1.635 16.218a80 80 0 0 0 4.688 15.102 80.5 80.5 0 0 0 7.419 13.668 81 81 0 0 0 9.826 11.91 81 81 0 0 0 11.91 9.826 80.5 80.5 0 0 0 13.667 7.418 80 80 0 0 0 15.103 4.689 81 81 0 0 0 16.218 1.634c13.438 0 23.898-.459 32.917-1.445 11.494-1.257 20.824-3.383 28.524-6.5 4.255-1.723 8.051-3.783 11.282-6.123 3.416-2.473 6.322-5.347 8.637-8.54 2.439-3.365 4.307-7.2 5.552-11.4 1.311-4.422 1.976-9.393 1.976-14.773 0-3.659.033-7.09.066-10.41.18-18.494.31-31.857-5.898-46.824-1.593-3.84-3.539-7.655-5.95-11.663-2.496-4.15-5.426-8.4-8.955-12.993-7.113-9.253-16.713-19.894-29.35-32.53-11.11-11.11-23.231-16.743-36.03-16.743m0-1c12.206 0 24.704 5.002 36.737 17.035 55.474 55.474 50.38 70.136 50.38 115.128s-44.896 49.781-89.888 49.781-81.466-36.473-81.466-81.465c0-35.233 40.173-100.479 84.237-100.479"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#product_insigts_svg__a)",
    transform: "translate(.001 .004)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.883 22.501c31.657 0 52.156 17.307 68.756 48.136 10.476 19.454 31.305 46.53 30.489 72.753-2.081 66.893-99.225 61.031-130.147 53.774S9.086 147.501 27.36 102.859s28.455-80.358 80.523-80.358",
    "data-name": "Path 16564"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10020"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__b)",
    "data-name": "Group 10019",
    transform: "translate(31.145 69.372)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m142.391 57.283 1.634 2.829 1.634 2.829 1.646-2.823 1.645-2.823h-2.266l.021-10.908h-2.025l-.022 10.908Z",
    "data-name": "Path 16175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m148.209 49.794.974 1.687.974 1.687.981-1.683.981-1.683h-1.352l.013-6.5h-1.207l-.013 6.505Z",
    "data-name": "Path 16176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m32.847 0-1.646 2.822-1.644 2.824h2.266l-.022 10.908h2.025l.022-10.908h2.267L34.48 2.829Z",
    "data-name": "Path 16177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m29.658 12.833-.988-1.711-.988-1.71-.995 1.706-.99 1.707h1.37l-.013 6.595h1.224l.013-6.595Z",
    "data-name": "Path 16178"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9976"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__b)",
    "data-name": "Group 9975"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M149.212 93.506c-4.049-2.638-5.077-7.689-5.032-12.252a4.9 4.9 0 0 1 .255-2.238 1.59 1.59 0 0 1 1.9-.849c.582.252.849.9 1.184 1.44a4.5 4.5 0 0 0 1.859 1.662 1.75 1.75 0 0 0 1.594.1c.66-.378.716-1.287.693-2.044l-.131-4.231a7 7 0 0 1 .177-2.253 2.36 2.36 0 0 1 1.463-1.624 1.456 1.456 0 0 1 1.818.912 7 7 0 0 1 .045.942.8.8 0 0 0 .493.739.94.94 0 0 0 .838-.368 10 10 0 0 0 1.772-2.772 14 14 0 0 1 1.646-2.855 4.18 4.18 0 0 1 2.785-1.623 2.5 2.5 0 0 1 2.6 1.611 3.63 3.63 0 0 1-.97 3.038 17 17 0 0 1-3.5 3.438 1.4 1.4 0 0 0-.584.647c-.155.509.344 1 .855 1.152a9 9 0 0 0 1.8.156 1.74 1.74 0 0 1 1.5.852c.335.766-.3 1.593-.939 2.139a14.8 14.8 0 0 1-4.3 2.576 5 5 0 0 0-1.6.812 1.385 1.385 0 0 0-.418 1.615 1.47 1.47 0 0 0 1.594.559 10.4 10.4 0 0 0 1.675-.675 2.73 2.73 0 0 1 3.119.5 2.36 2.36 0 0 1 .312 2.112 5.5 5.5 0 0 1-1.122 1.9 14.8 14.8 0 0 1-6.219 4.518 10.35 10.35 0 0 1-7.169.357",
    "data-name": "Path 16179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M164.034 66.793s-.024.026-.074.073l-.225.205c-.2.179-.49.444-.856.8a28.5 28.5 0 0 0-2.87 3.189c-.557.715-1.133 1.523-1.737 2.4s-1.238 1.825-1.87 2.843a34 34 0 0 0-1.823 3.281c-.283.586-.533 1.2-.788 1.822l-.772 1.9a69 69 0 0 0-2.566 7.351 33.3 33.3 0 0 0-1.129 6.244 24 24 0 0 0 .038 4.278c.053.5.1.893.147 1.156l.044.3c.01.073.011.1.011.1a16 16 0 0 1-.247-1.554 23.4 23.4 0 0 1-.074-4.289 33 33 0 0 1 1.107-6.266 67 67 0 0 1 2.562-7.366l.772-1.9c.255-.622.507-1.239.792-1.827a34 34 0 0 1 1.834-3.288c.635-1.019 1.276-1.962 1.881-2.841s1.189-1.684 1.751-2.4a27 27 0 0 1 2.9-3.171c.372-.347.668-.607.872-.781l.232-.2c.052-.044.082-.064.082-.064",
    "data-name": "Path 16180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M154.507 79.521a1.7 1.7 0 0 1-.079-.322c-.044-.208-.1-.512-.161-.888-.125-.751-.264-1.795-.413-2.945s-.306-2.19-.448-2.936a31 31 0 0 0-.174-.883 2 2 0 0 1-.056-.326 2 2 0 0 1 .1.316c.059.205.131.506.21.878.162.745.332 1.785.482 2.938s.28 2.173.38 2.948l.124.892a2 2 0 0 1 .034.329",
    "data-name": "Path 16181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M164.368 77.466a.4.4 0 0 1-.1.019l-.293.032c-.254.027-.621.064-1.074.126-.9.115-2.15.32-3.513.605s-2.585.6-3.461.856c-.44.124-.792.234-1.036.309l-.282.085a.052.052 0 1 1-.008-.022l.275-.105c.24-.088.59-.21 1.027-.344.873-.274 2.1-.6 3.461-.891s2.617-.479 3.528-.574c.455-.051.824-.077 1.08-.09l.294-.011a.4.4 0 0 1 .1 0",
    "data-name": "Path 16182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M150.458 90.433a.6.6 0 0 1-.068-.118l-.176-.349c-.152-.3-.36-.748-.612-1.3-.5-1.1-1.151-2.65-1.844-4.366s-1.328-3.265-1.812-4.376l-.578-1.315-.156-.358a.069.069 0 1 1 .021-.01l.176.349c.152.3.36.748.612 1.3.5 1.1 1.151 2.651 1.844 4.367s1.329 3.264 1.812 4.376l.578 1.314.156.358a.6.6 0 0 1 .048.128",
    "data-name": "Path 16183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M163.519 85.956a.7.7 0 0 1-.13.054l-.38.132-1.4.478c-1.181.405-2.807.985-4.6 1.63s-3.425 1.213-4.615 1.6c-.595.193-1.077.345-1.412.444l-.387.112a.071.071 0 1 1-.007-.022l.38-.132 1.4-.478c1.182-.405 2.807-.985 4.6-1.63s3.425-1.213 4.614-1.6a61 61 0 0 1 1.412-.444l.387-.112a.7.7 0 0 1 .137-.031",
    "data-name": "Path 16184"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9978"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__b)",
    "data-name": "Group 9977"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b7bbbc",
    d: "M163.964 102.327c0 .039-36.707.07-81.978.07-45.286 0-81.986-.031-81.986-.07s36.7-.07 81.986-.07c45.271 0 81.978.031 81.978.07",
    "data-name": "Path 16185"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9983"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__b)",
    "data-name": "Group 9982"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M16.866 93.964a5.1 5.1 0 0 0-3.145-.38 2.62 2.62 0 0 0-1.553.69 1.11 1.11 0 0 0-.016 1.544 1.5 1.5 0 0 0 .98.248 3.88 3.88 0 0 1 2.418.342c.379.284.631.756 1.084.9a1.07 1.07 0 0 0 1.178-.522 1.81 1.81 0 0 0 .133-1.345 2.05 2.05 0 0 0-1.079-1.473",
    "data-name": "Path 16186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M19.059 89.754a1.51 1.51 0 0 1-2.249.049 4.2 4.2 0 0 1-.953-1.945 10.3 10.3 0 0 1-.586-4.916 2.73 2.73 0 0 1 .631-1.337 1.44 1.44 0 0 1 1.359-.45 2.1 2.1 0 0 1 1.187 1.241 11.7 11.7 0 0 1 1.163 5.03 4.05 4.05 0 0 1-.552 2.328",
    "data-name": "Path 16187"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9981",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9980"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__c)",
    "data-name": "Group 9979",
    transform: "translate(15.151 81.117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.908 8.636a1.51 1.51 0 0 1-2.249.049A4.2 4.2 0 0 1 .706 6.74 10.3 10.3 0 0 1 .12 1.824 2.73 2.73 0 0 1 .751.487 1.44 1.44 0 0 1 2.11.037a2.1 2.1 0 0 1 1.187 1.241 11.7 11.7 0 0 1 1.163 5.03 4.05 4.05 0 0 1-.552 2.328",
    "data-name": "Path 16188"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M20.664 90.947a3.01 3.01 0 0 1-.473-2.784 5.37 5.37 0 0 1 1.657-2.392 8.9 8.9 0 0 1 2.967-1.742 3.2 3.2 0 0 1 1.334-.225 1.4 1.4 0 0 1 1.12.674 2.08 2.08 0 0 1-.311 1.9 22.5 22.5 0 0 1-1.949 2.954 5.27 5.27 0 0 1-2.143 1.828 1.95 1.95 0 0 1-2.287-.316",
    "data-name": "Path 16189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M19.098 102.297a1.7 1.7 0 0 1-.053-.378l-.1-1.031a15 15 0 0 0-.233-1.513 12 12 0 0 0-.553-1.785 6.6 6.6 0 0 0-.916-1.615 3.4 3.4 0 0 0-1.158-.958 3.3 3.3 0 0 0-.975-.3 2 2 0 0 1-.378-.054 1.8 1.8 0 0 1 .385-.006 3 3 0 0 1 1.017.263 3.4 3.4 0 0 1 1.222.966 6.5 6.5 0 0 1 .949 1.648 11 11 0 0 1 .549 1.814 13 13 0 0 1 .2 1.532c.032.438.045.792.051 1.038a1.7 1.7 0 0 1-.008.381",
    "data-name": "Path 16190"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M19.026 101.503a.8.8 0 0 1-.01-.176v-.5c0-.435 0-1.065-.022-1.842-.039-1.555-.173-3.7-.433-6.061s-.609-4.483-.925-6.006q-.113-.573-.221-1.026c-.108-.453-.125-.562-.181-.772l-.118-.487a.8.8 0 0 1-.031-.173.7.7 0 0 1 .061.164l.147.48c.065.208.131.467.207.767s.162.642.244 1.024a57 57 0 0 1 .972 6.012c.26 2.364.377 4.517.388 6.076.009.779-.007 1.41-.028 1.845l-.031.5a.7.7 0 0 1-.021.174",
    "data-name": "Path 16191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M19.015 97.352a3.3 3.3 0 0 1 0-.524 14 14 0 0 1 .161-1.419 19 19 0 0 1 .464-2.067 18 18 0 0 1 .869-2.446 13 13 0 0 1 2.551-3.953 6 6 0 0 1 .6-.555c.092-.078.173-.155.256-.216l.233-.16a3.3 3.3 0 0 1 .443-.282 16 16 0 0 0-1.452 1.289 13.7 13.7 0 0 0-2.487 3.939 19 19 0 0 0-.873 2.424 21 21 0 0 0-.494 2.047c-.109.59-.171 1.071-.209 1.4a3.4 3.4 0 0 1-.065.519",
    "data-name": "Path 16192"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.43 9.712h83.203v64.441H40.43z",
    "data-name": "Rectangle 3070"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10009"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__b)",
    "data-name": "Group 10008"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m123.632 74.153-.058-64.441.058.058-83.2.012h-.007l.07-.07c0 23.228 0 45.2-.007 64.441l-.063-.063 83.2.063-83.2.063h-.054v-.063c0-19.243 0-41.213-.007-64.441v-.07h.077l83.2.012h.058v.058l-.058 64.441",
    "data-name": "Path 16193"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M63.308 68.74c-.039 0-.07-7.005-.07-15.644s.032-15.645.07-15.645.07 7 .07 15.645-.032 15.644-.07 15.644",
    "data-name": "Path 16194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M99.421 68.74c-.039 0-.07-7.005-.07-15.644s.032-15.645.07-15.645.07 7 .07 15.645-.032 15.644-.07 15.644",
    "data-name": "Path 16195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M75.635 68.74c-.039 0-.07-8.955-.07-20s.032-20 .07-20 .07 8.953.07 20-.032 20-.07 20",
    "data-name": "Path 16196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M50.647 68.74c-.039 0-.07-8.955-.07-20s.032-20 .07-20 .07 8.953.07 20-.032 20-.07 20",
    "data-name": "Path 16197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M113.589 68.74c-.039 0-.07-8.955-.07-20s.032-20 .07-20 .07 8.953.07 20-.032 20-.07 20",
    "data-name": "Path 16198"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M86.444 68.741c-.039 0-.07-10.34-.07-23.092s.032-23.094.07-23.094.07 10.338.07 23.094-.032 23.092-.07 23.092",
    "data-name": "Path 16199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M63.603 37.451a.295.295 0 1 1-.295-.293.294.294 0 0 1 .295.293",
    "data-name": "Path 16200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M75.93 28.74a.295.295 0 1 1-.295-.293.294.294 0 0 1 .295.293",
    "data-name": "Path 16201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M75.635 29.77a1.029 1.029 0 1 1 1.034-1.029 1.033 1.033 0 0 1-1.034 1.029m0-1.991a.962.962 0 1 0 .967.962.966.966 0 0 0-.967-.962",
    "data-name": "Path 16202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M86.74 22.554a.295.295 0 1 1-.295-.293.294.294 0 0 1 .295.293",
    "data-name": "Path 16203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M99.712 37.744a.295.295 0 1 1-.295-.293.294.294 0 0 1 .295.293",
    "data-name": "Path 16204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M113.892 28.74a.295.295 0 1 1-.295-.293.294.294 0 0 1 .295.293",
    "data-name": "Path 16205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M50.943 29.033a.295.295 0 1 1-.295-.293.294.294 0 0 1 .295.293",
    "data-name": "Path 16206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M116.381 42.897a1 1 0 0 1-.232.075 5 5 0 0 0-.669.228 6.45 6.45 0 0 0-2.148 1.623c-.8.867-1.61 2.075-2.621 3.432a16.7 16.7 0 0 1-1.781 2.058 10 10 0 0 1-1.157.951 8 8 0 0 1-1.393.758 7.9 7.9 0 0 1-3.336.558 9 9 0 0 1-1.795-.224 4.7 4.7 0 0 1-1.737-.761 5.6 5.6 0 0 1-1.356-1.409c-.375-.539-.71-1.11-1.035-1.691a59 59 0 0 0-2.086-3.52c-.751-1.195-1.447-2.454-2.225-3.692a17.7 17.7 0 0 0-2.725-3.5 8 8 0 0 0-1.83-1.3 6.1 6.1 0 0 0-2.174-.633 7.8 7.8 0 0 0-2.314.13 7.8 7.8 0 0 0-2.2.83 11.4 11.4 0 0 0-3.432 3.186 35 35 0 0 0-2.453 3.926 40 40 0 0 1-2.377 3.841 19 19 0 0 1-2.878 3.265 11 11 0 0 1-.835.661 10 10 0 0 1-.884.575 7.7 7.7 0 0 1-1.917.785 6.4 6.4 0 0 1-1 .186 3.5 3.5 0 0 1-.5.029c-.167 0-.334.013-.5.006a7.6 7.6 0 0 1-1.92-.354 13 13 0 0 1-3.245-1.688c-.964-.66-1.845-1.344-2.707-1.961a14.5 14.5 0 0 0-2.57-1.55 8.5 8.5 0 0 0-2.558-.724 6.3 6.3 0 0 0-2.3.148 4 4 0 0 0-.5.16 3 3 0 0 0-.464.182 6 6 0 0 0-.812.448 8.7 8.7 0 0 0-1.222.973l-.425.464a4 4 0 0 0-.341.395l-.43.564a1 1 0 0 1-.159.185 1 1 0 0 1 .123-.209l.4-.592a4 4 0 0 1 .328-.411l.416-.483a8.4 8.4 0 0 1 1.221-1.023 6 6 0 0 1 .826-.477 3 3 0 0 1 .476-.2 4 4 0 0 1 .511-.173 6.5 6.5 0 0 1 2.376-.189 8.7 8.7 0 0 1 2.642.713 14.6 14.6 0 0 1 2.635 1.552c.873.614 1.759 1.29 2.716 1.935a12.8 12.8 0 0 0 3.169 1.624 7.3 7.3 0 0 0 1.827.327c.157.005.315-.006.474-.009a3 3 0 0 0 .476-.03 6 6 0 0 0 .948-.181 8.6 8.6 0 0 0 3.473-1.955 18.6 18.6 0 0 0 2.8-3.205 40 40 0 0 0 2.345-3.81 35.5 35.5 0 0 1 2.478-3.976 11.8 11.8 0 0 1 3.561-3.3 8.1 8.1 0 0 1 4.76-1.01 6.5 6.5 0 0 1 2.32.679 8.3 8.3 0 0 1 1.925 1.375 18 18 0 0 1 2.783 3.586c.782 1.253 1.475 2.515 2.214 3.7a59 59 0 0 1 2.08 3.545 8.8 8.8 0 0 0 2.271 3 4.4 4.4 0 0 0 1.614.717 8.7 8.7 0 0 0 1.727.227 7.6 7.6 0 0 0 3.21-.51 7.8 7.8 0 0 0 1.346-.716 9.6 9.6 0 0 0 1.132-.912 16.6 16.6 0 0 0 1.778-2.005 43 43 0 0 1 2.689-3.4 6.3 6.3 0 0 1 2.237-1.59 4 4 0 0 1 .692-.191 1 1 0 0 1 .242-.033",
    "data-name": "Path 16207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M50.353 16.945H64.86v.804H50.353z",
    "data-name": "Rectangle 3071"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M50.352 18.826h7.169v.804h-7.169z",
    "data-name": "Rectangle 3072"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M122.413 4.455H41.551a1.217 1.217 0 0 0-1.22 1.214v4.043h83.3V5.669a1.217 1.217 0 0 0-1.22-1.214",
    "data-name": "Path 16208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.648 7.185a.568.568 0 1 1-.568-.566.567.567 0 0 1 .568.566",
    "data-name": "Path 16209"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.128 7.185a.568.568 0 1 1-.568-.566.567.567 0 0 1 .568.566",
    "data-name": "Path 16210"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.61 7.185a.568.568 0 1 1-.569-.566.57.57 0 0 1 .569.566",
    "data-name": "Path 16211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M41.634 57.166H9.218a.87.87 0 0 1-.874-.87v-7.794a.87.87 0 0 1 .874-.87h32.416a.87.87 0 0 1 .874.87v7.794a.87.87 0 0 1-.874.87",
    "data-name": "Path 16212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.545 53.989a2.09 2.09 0 0 1-2.927.32 2.065 2.065 0 0 1-.322-2.912 2.09 2.09 0 0 1 2.927-.321 2.066 2.066 0 0 1 .322 2.913",
    "data-name": "Path 16213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M15.091 51.99a9.6 9.6 0 0 1-1.126 1.191l-.275.264-.049.047-.048-.048a6.7 6.7 0 0 1-.842-.936 6.7 6.7 0 0 1 .939.839h-.1l.272-.267a9.6 9.6 0 0 1 1.225-1.091",
    "data-name": "Path 16214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M39.174 51.7c0 .039-4.343.07-9.7.07s-9.7-.031-9.7-.07 4.342-.07 9.7-.07 9.7.031 9.7.07",
    "data-name": "Path 16215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M31.217 53.586c0 .039-2.511.07-5.607.07s-5.608-.031-5.608-.07 2.51-.07 5.608-.07 5.607.031 5.607.07",
    "data-name": "Path 16216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M51.403 38.583H19.137a.706.706 0 0 1-.708-.7V25.365a.706.706 0 0 1 .708-.7h32.266a.707.707 0 0 1 .708.7v12.513a.707.707 0 0 1-.708.7",
    "data-name": "Path 16217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M25.426 29.06a1.57 1.57 0 1 1-1.57-1.563 1.567 1.567 0 0 1 1.57 1.563",
    "data-name": "Path 16218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M26.997 27.981h10.941v.605H26.997z",
    "data-name": "Rectangle 3073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.997 29.355H48.28v.605H26.997z",
    "data-name": "Rectangle 3074"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M25.426 33.865a1.57 1.57 0 1 1-1.57-1.563 1.567 1.567 0 0 1 1.57 1.563",
    "data-name": "Path 16219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M26.997 32.786h5.587v.604h-5.587z",
    "data-name": "Rectangle 3075"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.997 34.16H48.28v.604H26.997z",
    "data-name": "Rectangle 3076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M66.749 79.659H25.436a1.07 1.07 0 0 1-1.072-1.067V62.338a1.07 1.07 0 0 1 1.072-1.066h41.313a1.07 1.07 0 0 1 1.072 1.066v16.253a1.07 1.07 0 0 1-1.072 1.067",
    "data-name": "Path 16220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "m32.315 70.159-.021-3.729a4.8 4.8 0 0 0-3.091 1.2 4.4 4.4 0 0 0-1.489 3.862 5 5 0 0 0 .08.538v.013l4.514-1.011Z",
    "data-name": "Path 16221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M36.968 69.015a4.44 4.44 0 0 0-3.644-2.539l-.143-.013-.091-.007a5 5 0 0 0-.272-.008h-.024l.024 3.73.006.876 4.516.981h.005a4.4 4.4 0 0 0 .1-.967 4.8 4.8 0 0 0-.477-2.053",
    "data-name": "Path 16222"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9986",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9985"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__d)",
    "data-name": "Group 9984",
    transform: "translate(32.794 66.444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.174 2.571A4.44 4.44 0 0 0 .53.032L.387.019.296.012A5 5 0 0 0 .024.004H0l.024 3.73.006.876 4.516.981h.005a4.4 4.4 0 0 0 .1-.967 4.8 4.8 0 0 0-.477-2.053",
    "data-name": "Path 16223"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "m32.556 71.5-4.514 1.012a4.632 4.632 0 0 0 9.036-.03l-4.516-.981",
    "data-name": "Path 16224"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9989",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9988"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__e)",
    "data-name": "Group 9987",
    transform: "translate(28.042 71.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.514 0 0 1.012a4.632 4.632 0 0 0 9.036-.03L4.52.001",
    "data-name": "Path 16225"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.47 67.545h22.937v1.034H40.47z",
    "data-name": "Rectangle 3079"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.47 70.271h22.937v1.034H40.47z",
    "data-name": "Rectangle 3080"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.47 73.287h12.397v1.034H40.47z",
    "data-name": "Rectangle 3081"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M118.056 91.666H77.297A2.27 2.27 0 0 1 75.02 89.4V50.504a2.27 2.27 0 0 1 2.277-2.267h40.759a2.27 2.27 0 0 1 2.277 2.267v38.892a2.27 2.27 0 0 1-2.277 2.266",
    "data-name": "Path 16226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M78.187 77.986h1.487v.426h-1.487z",
    "data-name": "Rectangle 3082"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M81.552 80.266h1.902v.426h-1.902z",
    "data-name": "Rectangle 3083"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M88.172 80.266h1.902v.426h-1.902z",
    "data-name": "Rectangle 3084"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M94.793 80.266h1.902v.426h-1.902z",
    "data-name": "Rectangle 3085"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M101.413 80.266h1.902v.426h-1.902z",
    "data-name": "Rectangle 3086"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M108.034 80.266h1.902v.426h-1.902z",
    "data-name": "Rectangle 3087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M114.654 80.266h1.902v.426h-1.902z",
    "data-name": "Rectangle 3088"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M78.187 72.288h1.487v.426h-1.487z",
    "data-name": "Rectangle 3089"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M78.187 61.566h1.487v.426h-1.487z",
    "data-name": "Rectangle 3090"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M78.187 56.178h1.487v.426h-1.487z",
    "data-name": "Rectangle 3091"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M78.262 66.928h1.487v.426h-1.487z",
    "data-name": "Rectangle 3092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M116.5 78.412s-.054 0-.159.007l-.468.007-1.8.013-6.618.023-21.834.02H80.38v-.069l.024-18.246.021-5.388.012-1.45q-.002-.241.006-.376c.008-.135.006-.128.006-.128s0 .043.006.128 0 .214.006.376c0 .336.007.823.012 1.45 0 1.269.012 3.1.021 5.388l.024 18.246-.069-.069h5.174l21.834.02 6.618.023 1.8.013.468.007c.105 0 .159.007.159.007",
    "data-name": "Path 16227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M116.922 67.145c0 .039-7.843.07-17.516.07s-17.517-.031-17.517-.07 7.841-.07 17.517-.07 17.516.031 17.516.07",
    "data-name": "Path 16228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M116.922 61.779c0 .039-7.843.07-17.516.07s-17.517-.031-17.517-.07 7.841-.07 17.517-.07 17.516.031 17.516.07",
    "data-name": "Path 16229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M116.922 56.391c0 .039-7.843.07-17.516.07s-17.517-.031-17.517-.07 7.841-.07 17.517-.07 17.516.031 17.516.07",
    "data-name": "Path 16230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M116.922 72.501c0 .039-7.843.07-17.516.07s-17.517-.031-17.517-.07 7.841-.07 17.517-.07 17.516.031 17.516.07",
    "data-name": "Path 16231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M82.25 77.258v-4.756l2.979-4.6 2.021 1.544 4.149-6.414 2.447 1.715 3.4-5.917 2.766 2.242 4.148-7.849 4.468 8.773 3.617-4.39 4.255-1.212v20.867Z",
    "data-name": "Path 16232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M116.922 54.7a.4.4 0 0 1-.075.005l-.222.005-.864.01-3.265.018.031-.015-3.5 4.552-.017.022h-.028l-8.76.012.058-.033-3.683 6.1-3.616 5.982-.053.088-.06-.083-4.745-6.495h.1l-4.329 6.713-1.208 1.856-.32.484c-.073.109-.115.163-.115.163s.032-.06.1-.172l.306-.494 1.181-1.872 4.287-6.739.045-.071.05.068 4.762 6.482-.113.005 3.611-5.984 3.688-6.1.02-.033h.038l8.76.012-.044.021 3.525-4.532.012-.015h.019l3.265.018.864.01.222.005a.4.4 0 0 1 .075.005",
    "data-name": "Path 16233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M89.608 66.365a.336.336 0 1 1-.336-.322.33.33 0 0 1 .336.322",
    "data-name": "Path 16234"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M99.712 60.649a.336.336 0 1 1-.336-.322.33.33 0 0 1 .336.322",
    "data-name": "Path 16235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M107.567 59.244a.336.336 0 1 1-.336-.322.33.33 0 0 1 .336.322",
    "data-name": "Path 16236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.899 85.966a2.175 2.175 0 1 1-2.173-2.083 2.13 2.13 0 0 1 2.173 2.083",
    "data-name": "Path 16237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M89.123 84.57h25.531v.779H89.123z",
    "data-name": "Rectangle 3093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M89.123 86.517h10.601v.779H89.123z",
    "data-name": "Rectangle 3094"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M134.497 39.345h-27.414a1.333 1.333 0 0 1-1.336-1.33V15.839a1.333 1.333 0 0 1 1.336-1.331h27.413a1.333 1.333 0 0 1 1.336 1.331v22.176a1.333 1.333 0 0 1-1.336 1.33",
    "data-name": "Path 16238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M110.998 24.452h1.622v12.187h-1.622z",
    "data-name": "Rectangle 3095"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M118.369 23.464h1.622V36.64h-1.622z",
    "data-name": "Rectangle 3096"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M126.004 21.79h1.622v14.849h-1.622z",
    "data-name": "Rectangle 3097"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M122.417 30.705h1.622v5.934h-1.622z",
    "data-name": "Rectangle 3098"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9992",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9991"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__f)",
    "data-name": "Group 9990",
    transform: "translate(122.417 30.705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.622v5.934H0z",
    "data-name": "Rectangle 3099"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M112.888 23.147h1.622v13.492h-1.622z",
    "data-name": "Rectangle 3101"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9995",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9994"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__g)",
    "data-name": "Group 9993",
    transform: "translate(112.888 23.147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.622v13.492H0z",
    "data-name": "Rectangle 3102"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M120.391 20.32h1.622v16.319h-1.622z",
    "data-name": "Rectangle 3104"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9998",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9997"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__h)",
    "data-name": "Group 9996",
    transform: "translate(120.391 20.32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.622v16.319H0z",
    "data-name": "Rectangle 3105"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M130.187 20.32h1.622v16.319h-1.622z",
    "data-name": "Rectangle 3107"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10001",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10000"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__h)",
    "data-name": "Group 9999",
    transform: "translate(130.187 20.32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.622v16.319H0z",
    "data-name": "Rectangle 3108"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M128.07 17.097h1.622v19.542h-1.622z",
    "data-name": "Rectangle 3110"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10004",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10003"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__i)",
    "data-name": "Group 10002",
    transform: "translate(128.07 17.097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.622v19.542H0z",
    "data-name": "Rectangle 3111"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M114.872 28.076h1.622v8.563h-1.622z",
    "data-name": "Rectangle 3113"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10007",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10006"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__j)",
    "data-name": "Group 10005",
    transform: "translate(114.871 28.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.622v8.563H0z",
    "data-name": "Rectangle 3114"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M134.129 37.378c0 .039-5.787.07-12.925.07s-12.926-.031-12.926-.07 5.786-.07 12.926-.07 12.925.031 12.925.07",
    "data-name": "Path 16239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M107.528 34.471h.989v.325h-.989z",
    "data-name": "Rectangle 3116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M107.528 30.135h.989v.325h-.989z",
    "data-name": "Rectangle 3117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M107.528 21.973h.989v.325h-.989z",
    "data-name": "Rectangle 3118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M107.528 17.871h.989v.325h-.989z",
    "data-name": "Rectangle 3119"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M107.578 26.054h.989v.325h-.989z",
    "data-name": "Rectangle 3120"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M101.087 21.102h-29.11a.87.87 0 0 1-.875-.87v-6.875a.87.87 0 0 1 .875-.87h29.11a.87.87 0 0 1 .874.87v6.871a.87.87 0 0 1-.874.87",
    "data-name": "Path 16240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.607 18.232a1.886 1.886 0 0 1-2.643.289 1.865 1.865 0 0 1-.29-2.631 1.887 1.887 0 0 1 2.643-.29 1.866 1.866 0 0 1 .29 2.631",
    "data-name": "Path 16241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M76.137 18.939a1.884 1.884 0 0 1-1.872-1.673 1.88 1.88 0 0 1 1.669-2.072 2 2 0 0 1 .21-.012 1.885 1.885 0 0 1 1.872 1.673 1.88 1.88 0 0 1-1.669 2.072 2 2 0 0 1-.21.012m.007-3.744a2 2 0 0 0-.208.012 1.87 1.87 0 1 0 .208-.012",
    "data-name": "Path 16242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M77.197 16.425a8 8 0 0 1-1.013 1.081l-.248.238-.05.047-.047-.048a5.4 5.4 0 0 1-.756-.849 5.5 5.5 0 0 1 .853.753h-.1l.246-.241a8 8 0 0 1 1.111-.98",
    "data-name": "Path 16243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.95 16.164c0 .039-3.923.07-8.761.07s-8.761-.031-8.761-.07 3.922-.07 8.761-.07 8.761.031 8.761.07",
    "data-name": "Path 16244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.763 17.867c0 .039-2.268.07-5.065.07s-5.065-.031-5.065-.07 2.267-.07 5.065-.07 5.065.031 5.065.07",
    "data-name": "Path 16245"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10011"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#263238",
    clipPath: "url(#product_insigts_svg__b)",
    "data-name": "Group 10010"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.29 28.874s-.036.046-.112.129-.187.21-.345.364a6.6 6.6 0 0 1-1.57 1.089 5 5 0 0 1-.6.258l-.333.119-.357.093a7 7 0 0 1-.771.147c-.136.015-.274.021-.415.033a3 3 0 0 1-.43.011 6.53 6.53 0 0 1-3.7-1.184l.045.01-3.218.618-.181.035.121-.139 1.772-2.031v.084a6.5 6.5 0 0 1-1.222-3.02 6.47 6.47 0 0 1 .487-3.418 6.5 6.5 0 0 1 7.149-3.783 6.46 6.46 0 0 1 3.335 1.714 6.375 6.375 0 0 1 1.328 7.43l-.182.354c-.061.108-.129.2-.187.295a3.5 3.5 0 0 1-.317.446l-.214.26a1 1 0 0 1-.076.085 1 1 0 0 1 .065-.094l.2-.268a4 4 0 0 0 .3-.451c.055-.092.121-.188.18-.3l.174-.354a6.4 6.4 0 0 0 .566-1.939 6.38 6.38 0 0 0-1.926-5.383 6.36 6.36 0 0 0-3.278-1.671 6.37 6.37 0 0 0-7 3.712 6.35 6.35 0 0 0-.478 3.344 6.36 6.36 0 0 0 1.192 2.958l.032.044-.035.04-1.776 2.026-.06-.1 3.22-.607h.024l.02.014a6.45 6.45 0 0 0 3.635 1.185 3 3 0 0 0 .424-.007c.138-.01.275-.015.409-.029a7 7 0 0 0 .763-.139l.354-.089.33-.115a5 5 0 0 0 .6-.249 6.8 6.8 0 0 0 1.575-1.055c.16-.149.274-.273.356-.351l.125-.117",
    "data-name": "Path 16246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.509 23.319-1.087-.358-1.087-.358.232 1.116.232 1.116.591-.524 2.545 2.846.528-.468-2.545-2.846Z",
    "data-name": "Path 16247"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10016"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__b)",
    "data-name": "Group 10015"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "m139.238 98.373-1.753-1.752 3.276-3.289 2.591 2.536-.19.217a55 55 0 0 1-5.2 5.232c-.88.473 1.271-2.945 1.271-2.945",
    "data-name": "Path 16248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M142.139 97.036a1.6 1.6 0 0 1-.287-1.115 1.56 1.56 0 0 1 .526-1.006l.924.91Z",
    "data-name": "Path 16249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M138.235 100.091s-.692 1.259-.408 1.3 4.022-3.719 5.525-5.52l-.079-.068-4.32 4.417s-.516-.313-.715-.129",
    "data-name": "Path 16250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M143.322 95.748a.4.4 0 0 1-.05.063l-.152.172-.569.623a81 81 0 0 1-3.93 3.953l-.62.573-.171.153a1 1 0 0 1-.062.051.4.4 0 0 1 .054-.059l.164-.16.607-.586c.513-.5 1.218-1.183 1.985-1.954s1.449-1.48 1.941-2l.582-.611.16-.165a.4.4 0 0 1 .058-.055",
    "data-name": "Path 16251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M139.002 100.27a1.23 1.23 0 0 0-.831-.194.75.75 0 0 1 .831.194",
    "data-name": "Path 16252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M139.474 98.811a.5.5 0 0 1-.23-.021c-.123-.027-.221-.061-.218-.076a.5.5 0 0 1 .23.021c.124.027.221.061.218.076",
    "data-name": "Path 16253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M139.597 98.405c0 .015-.086.033-.193.039s-.2 0-.2-.016.085-.033.193-.04.2 0 .2.017",
    "data-name": "Path 16254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M139.453 97.93c.011.011-.055.1-.149.193s-.178.165-.189.154.055-.1.149-.193.178-.165.189-.154",
    "data-name": "Path 16255"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M139.29 97.655a.47.47 0 0 1-.135.247.48.48 0 0 1-.223.172c-.01-.014.084-.094.18-.208s.163-.218.178-.21",
    "data-name": "Path 16256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M139.074 98.639a.9.9 0 0 1-.212.21 2 2 0 0 1-.274.176 1 1 0 0 1-.181.076.16.16 0 0 1-.119-.013.12.12 0 0 1-.053-.116.55.55 0 0 1 .591-.367.5.5 0 0 1 .21.071c.045.028.065.049.063.051a.9.9 0 0 0-.277-.082.54.54 0 0 0-.3.064.46.46 0 0 0-.234.269c-.009.059.044.085.1.069a1 1 0 0 0 .17-.069 2 2 0 0 0 .273-.161c.149-.1.229-.185.236-.178",
    "data-name": "Path 16257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M139.03 98.704a.3.3 0 0 1-.172-.121.5.5 0 0 1-.1-.211.3.3 0 0 1 .067-.283.12.12 0 0 1 .163.031.3.3 0 0 1 .059.13 1 1 0 0 1 .029.227.4.4 0 0 1-.034.205c-.009 0 0-.08-.005-.2a1 1 0 0 0-.039-.214c-.016-.073-.077-.173-.139-.129a.26.26 0 0 0-.048.228.5.5 0 0 0 .078.2 1 1 0 0 0 .14.145",
    "data-name": "Path 16258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M142.351 94.923c.007.008-.1.086-.233.251a1.45 1.45 0 0 0-.168 1.542c.092.19.182.289.174.295s-.027-.02-.067-.065a1.2 1.2 0 0 1-.143-.212 1.4 1.4 0 0 1 .172-1.585 1.2 1.2 0 0 1 .185-.176.3.3 0 0 1 .079-.05",
    "data-name": "Path 16259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M140.636 93.908a16 16 0 0 1 1.376 1.322 16 16 0 0 1-1.376-1.322",
    "data-name": "Path 16260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M141.404 97.129a2.6 2.6 0 0 1-.43.527 2.7 2.7 0 0 1-.518.443c-.011-.013.217-.215.477-.483s.458-.5.471-.488",
    "data-name": "Path 16261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M142.045 96.486c.016 0 .028.063.056.133s.06.126.048.137-.069-.035-.1-.117-.018-.154 0-.153",
    "data-name": "Path 16262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M141.983 95.943c.016 0 .029.055.03.123s-.011.124-.027.124-.029-.055-.03-.123.011-.124.027-.124",
    "data-name": "Path 16263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M142.19 95.459c.009.014-.035.057-.066.122s-.04.126-.056.127-.035-.071.005-.151.11-.111.117-.1",
    "data-name": "Path 16264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M142.37 95.151c.014.006.013.042 0 .08s-.042.063-.056.057-.013-.042 0-.08.042-.063.056-.057",
    "data-name": "Path 16265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "m125.828 101.269.06-2.472 4.652.082-.05 3.617-.289.014a55 55 0 0 1-7.391-.119c-.952-.306 3.016-1.122 3.016-1.122",
    "data-name": "Path 16266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M128.805 102.43a1.6 1.6 0 0 1 .611-.977 1.57 1.57 0 0 1 1.093-.318l-.022 1.294Z",
    "data-name": "Path 16267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M123.888 101.736s-1.393.373-1.224.6 5.48.321 7.827.157l-.006-.1-6.2-.053s-.13-.587-.4-.6",
    "data-name": "Path 16268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M130.558 102.391a.4.4 0 0 1-.08.007l-.23.01-.846.022c-.715.014-1.7.019-2.793 0s-2.078-.056-2.792-.092l-.845-.049-.229-.017a.4.4 0 0 1-.08-.01.4.4 0 0 1 .08 0l.23.007.845.032c.714.027 1.7.058 2.791.076s2.077.018 2.791.015h1.076a.4.4 0 0 1 .08 0",
    "data-name": "Path 16269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M124.289 102.412a1.22 1.22 0 0 0-.434-.731.75.75 0 0 1 .434.731",
    "data-name": "Path 16270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M125.673 101.741c-.013.008-.078-.073-.144-.18s-.109-.2-.1-.209.077.073.143.18.109.2.1.209",
    "data-name": "Path 16271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.049 101.55c-.011.012-.083-.039-.162-.112s-.134-.142-.123-.153.083.039.162.112.135.142.124.153",
    "data-name": "Path 16272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.301 101.117a.55.55 0 0 1-.243.027.56.56 0 0 1-.243-.029.55.55 0 0 1 .243-.027.56.56 0 0 1 .243.029",
    "data-name": "Path 16273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.386 100.81a.69.69 0 0 1-.551.032 20 20 0 0 0 .551-.032",
    "data-name": "Path 16274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M125.523 101.335a.9.9 0 0 1-.3-.007 2 2 0 0 1-.317-.075 1 1 0 0 1-.181-.078.16.16 0 0 1-.072-.094.12.12 0 0 1 .048-.118.55.55 0 0 1 .675.171.5.5 0 0 1 .094.2c.011.051.01.08.006.08a.9.9 0 0 0-.132-.256.54.54 0 0 0-.252-.17.47.47 0 0 0-.357.018c-.048.034-.031.09.022.122a1 1 0 0 0 .167.074 2 2 0 0 0 .306.085c.179.034.292.037.292.046",
    "data-name": "Path 16275"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M125.445 101.349a.3.3 0 0 1-.031-.207.5.5 0 0 1 .086-.216.3.3 0 0 1 .252-.147.12.12 0 0 1 .09.139.3.3 0 0 1-.053.132 1 1 0 0 1-.144.178.43.43 0 0 1-.173.118c-.005-.007.06-.052.144-.145a1 1 0 0 0 .128-.176c.042-.062.072-.175 0-.19s-.153.064-.2.123a.5.5 0 0 0-.088.192 1 1 0 0 0-.008.2",
    "data-name": "Path 16276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M130.485 101.123c0 .011-.133-.015-.344.006a1.46 1.46 0 0 0-1.235.946c-.075.2-.084.331-.094.329a.3.3 0 0 1 0-.093 1.2 1.2 0 0 1 .055-.249 1.41 1.41 0 0 1 1.27-.972 1.2 1.2 0 0 1 .256.011.3.3 0 0 1 .091.023",
    "data-name": "Path 16277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M130.036 99.187a16 16 0 0 1-.009 1.9 16 16 0 0 1 .009-1.9",
    "data-name": "Path 16278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M128.228 101.969a2.7 2.7 0 0 1-.681.056 2.6 2.6 0 0 1-.679-.066c0-.016.305.008.68.01s.679-.016.68 0",
    "data-name": "Path 16279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M129.139 101.983c.011.012-.026.064-.058.132s-.05.13-.066.129-.023-.074.015-.153.1-.12.109-.108",
    "data-name": "Path 16280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M129.49 101.564c.011.011-.02.059-.069.106s-.1.077-.108.067.02-.059.069-.107.1-.077.108-.066",
    "data-name": "Path 16281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M129.984 101.377c0 .015-.065.014-.134.037s-.119.058-.131.047.028-.074.114-.1.156 0 .151.016",
    "data-name": "Path 16282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M130.336 101.296c.005.014-.022.038-.061.052s-.075.014-.08 0 .022-.038.061-.052.075-.014.08 0",
    "data-name": "Path 16283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5baab",
    d: "M128.322 48.291c-1.726 5.07-4.833 14.248-4.833 14.248a8 8 0 0 1-1.289.615 3.5 3.5 0 0 1-.948.1c-.29-.04-.479.292-.289.476a2.44 2.44 0 0 0 1.893.045c.9-.27.232 1.1-.065 1.547a8.8 8.8 0 0 0-1.07 2.131c.1.293.461.172.747-.286s1.145-1.786 1.269-1.717c.246.137-1.237 2.493-1.237 2.493s-.341.413-.079.615c.472.364 1.923-2.169 2.056-2.414.093-.171.216-.037.106.141s-1.376 2.253-.993 2.489 1.279-1.83 1.644-2.214c.414-.436-.831 1.728-.47 1.989.134.1.248.15.872-1.1a37 37 0 0 0 1.392-3.756c1.326-2.647 5.124-10.821 6.379-16.385",
    "data-name": "Path 16284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M129.237 35.918s3.691-1.064 4.419 4.56c.456 3.523 1.493 12.033 1.893 16.406.037.411-.222.249-.192.591.035.4.389.717.389 1 0 .9-1.037.886-1.037.886l-9.65.458s-.895.019-.9-.759c0-.591.387-.853.416-1.221.41-5.26.4-18.36 1-20.16.567-1.717.932-1.753 3.662-1.76",
    "data-name": "Path 16285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M129.968 36.191a2 2 0 0 1 .226.239c.136.151.324.358.527.593s.374.459.491.625a1.7 1.7 0 0 1 .174.279 2 2 0 0 1-.206-.255c-.125-.16-.3-.378-.5-.612s-.386-.446-.513-.6a1.7 1.7 0 0 1-.2-.264",
    "data-name": "Path 16286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M130.393 36.095a1 1 0 0 1-.154.072l-.427.176c-.362.143-.866.334-1.428.527s-1.076.355-1.45.466l-.444.125a1 1 0 0 1-.165.038 1 1 0 0 1 .159-.058l.439-.143a70.86 70.86 0 0 0 2.876-.993l.433-.159a1 1 0 0 1 .161-.052",
    "data-name": "Path 16287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M126.363 36.469a4.7 4.7 0 0 1 0 1.024 4.7 4.7 0 0 1 0-1.024",
    "data-name": "Path 16288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M132.968 37.928c0 .015-1.64.028-3.662.028s-3.662-.013-3.662-.028 1.639-.028 3.662-.028 3.662.013 3.662.028",
    "data-name": "Path 16289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M133.442 39.13a.5.5 0 0 1-.083 0l-.237-.006-.87-.031-2.869-.089-2.87-.052-.869-.012-.237-.005a.5.5 0 0 1-.083-.006.5.5 0 0 1 .083-.006h.237l.87-.006a118 118 0 0 1 5.74.142l.869.049.236.017a.5.5 0 0 1 .082.01",
    "data-name": "Path 16290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M133.555 40.186c0 .015-1.853.028-4.137.028s-4.138-.013-4.138-.028 1.852-.028 4.138-.028 4.137.013 4.137.028",
    "data-name": "Path 16291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M133.767 41.334c0 .015-1.92.028-4.288.028s-4.289-.013-4.289-.028 1.92-.028 4.289-.028 4.288.013 4.288.028",
    "data-name": "Path 16292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M133.961 42.594c0 .015-1.964.028-4.386.028s-4.386-.013-4.386-.028 1.963-.028 4.386-.028 4.386.013 4.386.028",
    "data-name": "Path 16293"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M134.082 43.854c0 .015-1.991.028-4.446.028s-4.446-.013-4.446-.028 1.99-.028 4.446-.028 4.446.013 4.446.028",
    "data-name": "Path 16294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M134.236 45.204c0 .015-2.025.028-4.523.028s-4.524-.013-4.524-.028 2.025-.028 4.524-.028 4.523.013 4.523.028",
    "data-name": "Path 16295"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M134.388 46.374c0 .015-2.06.028-4.6.028s-4.6-.013-4.6-.028 2.059-.028 4.6-.028 4.6.013 4.6.028",
    "data-name": "Path 16296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M134.584 47.659c0 .015-2.1.028-4.7.028s-4.7-.013-4.7-.028 2.1-.028 4.7-.028 4.7.013 4.7.028",
    "data-name": "Path 16297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M134.693 48.941c0 .015-2.128.028-4.752.028s-4.751-.013-4.751-.028 2.127-.028 4.751-.028 4.752.013 4.752.028",
    "data-name": "Path 16298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M134.842 50.228c0 .015-2.161.028-4.826.028s-4.826-.013-4.826-.028 2.161-.028 4.826-.028 4.826.013 4.826.028",
    "data-name": "Path 16299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M134.988 51.513c0 .015-2.194.028-4.9.028s-4.9-.013-4.9-.028 2.193-.028 4.9-.028 4.9.013 4.9.028",
    "data-name": "Path 16300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M135.131 52.798c0 .015-2.277.028-5.084.028s-5.084-.013-5.084-.028 2.276-.028 5.084-.028 5.084.013 5.084.028",
    "data-name": "Path 16301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M135.269 54.082c0 .015-2.35.028-5.247.028s-5.247-.013-5.247-.028 2.349-.028 5.247-.028 5.247.013 5.247.028",
    "data-name": "Path 16302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M135.402 55.367c0 .015-2.388.028-5.334.028s-5.334-.013-5.334-.028 2.388-.028 5.334-.028 5.334.013 5.334.028",
    "data-name": "Path 16303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M135.528 56.652c0 .015-2.417.028-5.4.028s-5.4-.013-5.4-.028 2.416-.028 5.4-.028 5.4.013 5.4.028",
    "data-name": "Path 16304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M135.455 57.937c0 .015-2.435.006-5.439-.021s-5.439-.061-5.439-.077 2.435-.006 5.439.021 5.439.061 5.439.077",
    "data-name": "Path 16305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M135.456 59.122c0 .015-2.524.053-5.638.083s-5.638.042-5.638.027 2.524-.052 5.638-.083 5.638-.042 5.638-.027",
    "data-name": "Path 16306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "M128.178 53.101a2.5 2.5 0 0 0 1.766-.456 5.4 5.4 0 0 0 1.257-1.383 12.9 12.9 0 0 0 2.187-6.365 28 28 0 0 0-.022-3.481 28.4 28.4 0 0 1-1.7 6.577 16.8 16.8 0 0 1-2.944 4.866",
    "data-name": "Path 16307"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10014",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10013"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__k)",
    "data-name": "Group 10012",
    transform: "translate(128.178 41.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.686a2.5 2.5 0 0 0 1.766-.456 5.4 5.4 0 0 0 1.257-1.383A12.9 12.9 0 0 0 5.21 3.482 28 28 0 0 0 5.188.001a28.4 28.4 0 0 1-1.7 6.577 16.8 16.8 0 0 1-2.944 4.866",
    "data-name": "Path 16308"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M134.265 54.267a10 10 0 0 1-.963.907 13 13 0 0 1-1.155.856 14 14 0 0 1-1.536.861 14 14 0 0 1-1.643.639 12 12 0 0 1-1.4.348 10 10 0 0 1-1.315.168 1 1 0 0 1 .091-.016l.261-.034c.227-.026.554-.077.955-.158a13 13 0 0 0 1.389-.358 13 13 0 0 0 3.166-1.494 13 13 0 0 0 1.158-.844c.316-.258.563-.477.727-.636l.192-.18a1 1 0 0 1 .069-.06",
    "data-name": "Path 16309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M131.616 48.189a.2.2 0 0 1-.054-.014l-.152-.048-.555-.192-1.817-.673c-.71-.26-1.362-.468-1.839-.605l-.565-.159-.154-.044a.3.3 0 0 1-.053-.019.2.2 0 0 1 .055.008l.156.033c.136.03.331.079.571.142.48.128 1.136.331 1.847.591s1.348.512 1.811.687l.549.209.149.059a.3.3 0 0 1 .051.024",
    "data-name": "Path 16310"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M131.616 48.191s.024-.073.075-.209l.219-.6c.185-.522.456-1.277.717-2.231a31 31 0 0 0 .63-3.415 4.3 4.3 0 0 0-.087-2.018 2.7 2.7 0 0 0-.545-.92 4 4 0 0 0-.392-.389 1.7 1.7 0 0 0-.46-.308 1.85 1.85 0 0 0-1.085-.111 2.6 2.6 0 0 0-.991.405 3.03 3.03 0 0 0-1.1 1.669l-1.1 3.3-.748 2.223-.206.6q-.074.208-.075.209c-.001.001.02-.074.065-.213l.2-.607.731-2.229 1.092-3.3a5.2 5.2 0 0 1 .4-.926 2.3 2.3 0 0 1 .716-.772 2.6 2.6 0 0 1 1.012-.415 1.9 1.9 0 0 1 1.117.115 1.7 1.7 0 0 1 .474.317 4 4 0 0 1 .4.4 2.8 2.8 0 0 1 .556.939 4.3 4.3 0 0 1 .085 2.043 31 31 0 0 1-.643 3.418c-.266.955-.543 1.709-.735 2.228s-.315.8-.315.8",
    "data-name": "Path 16311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m133.902 63.611.215 15.665a17.6 17.6 0 0 0 .339 3.219 12.6 12.6 0 0 0 1.645 4.5c1.277 1.774 5.771 6.79 5.771 6.79l-3.782 4.4s-8.021-6.358-8.538-12.23c-.263-2.983 0-20.818 0-20.818Z",
    "data-name": "Path 16312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m125.059 59.819-.1 40.528h6.268l1.106-35.261a5.38 5.38 0 0 0 2.134-2.71 8.4 8.4 0 0 0 .238-3.015Z",
    "data-name": "Path 16313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M124.679 99.369h6.812v.978h-6.812z",
    "data-name": "Rectangle 3124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m137.059 97.802 4.688-4.92.717.674-4.694 4.92Z",
    "data-name": "Path 16566"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M141.481 93.236a.2.2 0 0 1-.038.047l-.118.127-.434.465c-.366.392-.861.945-1.432 1.534l-1.484 1.485-.455.445-.126.119a.2.2 0 0 1-.047.039.3.3 0 0 1 .039-.046l.118-.127.442-.457 1.472-1.5 1.444-1.522c.187-.193.34-.347.447-.453l.125-.119a.2.2 0 0 1 .047-.039",
    "data-name": "Path 16314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m129.836 59.607-.02.1a1.7 1.7 0 0 1-.1.291 1.7 1.7 0 0 1-.266.422 6 6 0 0 1-.479.484 5 5 0 0 0-.572.627 1.85 1.85 0 0 0-.187.973l-.083 2.465-.1 2.987c-.036 1.073-.063 2.223-.1 3.43-.063 2.415-.156 5.071-.212 7.859l-.24 14.283q-.1 5.354-.114 5.915s0-.141 0-.41.008-.672.014-1.177l.061-4.329.224-14.284c.056-2.788.151-5.443.217-7.859.036-1.207.07-2.355.1-3.43s.075-2.074.108-2.987l.091-2.465a1.87 1.87 0 0 1 .2-.986 5 5 0 0 1 .579-.628 6 6 0 0 0 .481-.48 1.7 1.7 0 0 0 .369-.7q.025-.1.026-.1",
    "data-name": "Path 16315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.09 60.094c-.013.009-.053-.039-.089-.1s-.054-.126-.039-.132.054.041.089.1.052.123.039.132",
    "data-name": "Path 16316"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.448 60.496c-.01.012-.062-.021-.117-.073s-.089-.1-.077-.114.064.023.117.073.087.1.077.114",
    "data-name": "Path 16317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.907 60.781c-.006.014-.066 0-.133-.039s-.115-.075-.106-.088.068 0 .133.039.113.074.106.088",
    "data-name": "Path 16318"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.427 60.925c0 .015-.064.016-.138 0s-.132-.039-.127-.054.066-.015.138 0 .129.039.127.054",
    "data-name": "Path 16319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.967 60.906c0 .015-.055.036-.131.045s-.137 0-.137-.014.059-.03.131-.042.134 0 .137.01",
    "data-name": "Path 16320"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M128.473 60.722c.008.014-.042.05-.112.081s-.13.044-.134.03.045-.051.111-.081.127-.044.135-.03",
    "data-name": "Path 16321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M128.908 60.402c.011.011-.027.06-.085.109s-.112.079-.121.066.029-.061.084-.109.11-.077.121-.066",
    "data-name": "Path 16322"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M129.238 59.973c.014.007-.009.065-.05.128s-.085.107-.1.1.01-.067.05-.129.084-.1.1-.1",
    "data-name": "Path 16323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M129.379 59.635c.015 0 .02.029.012.055s-.027.042-.041.037-.02-.029-.012-.054.027-.042.042-.037",
    "data-name": "Path 16324"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.71 61.961c-.016 0-.026-.061-.024-.135s.017-.134.033-.134.026.061.023.136-.017.134-.033.133",
    "data-name": "Path 16325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.691 62.5c-.016 0-.026-.061-.024-.135s.018-.134.033-.134.026.062.024.136-.017.134-.033.133",
    "data-name": "Path 16326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.674 63.04c-.016 0-.026-.061-.024-.135s.017-.134.033-.134.026.061.024.135-.017.134-.033.134",
    "data-name": "Path 16327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.656 63.577c-.016 0-.026-.061-.024-.135s.017-.134.033-.134.026.061.024.135-.017.134-.033.134",
    "data-name": "Path 16328"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.64 64.116c-.016 0-.026-.061-.024-.135s.017-.134.032-.134.026.061.024.135-.017.134-.033.134",
    "data-name": "Path 16329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.624 64.655c-.016 0-.026-.061-.024-.135s.017-.134.033-.134.026.061.024.135-.016.134-.032.133",
    "data-name": "Path 16330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.608 65.193c-.016 0-.026-.061-.024-.135s.017-.134.033-.134.026.061.024.135-.017.134-.032.134",
    "data-name": "Path 16331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.591 65.733c-.016 0-.026-.061-.024-.135s.017-.134.032-.134.026.061.024.136-.017.134-.032.134",
    "data-name": "Path 16332"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.576 66.273c-.016 0-.027-.061-.024-.135s.017-.135.032-.134.026.061.024.136-.016.134-.032.134",
    "data-name": "Path 16333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.561 66.81c-.016 0-.027-.061-.024-.135s.016-.135.032-.134.027.061.025.136-.017.134-.032.134",
    "data-name": "Path 16334"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.546 67.351c-.016 0-.027-.061-.024-.135s.016-.135.032-.134.027.061.025.136-.016.134-.032.134",
    "data-name": "Path 16335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.532 67.891c-.016 0-.027-.061-.025-.135s.017-.135.032-.134.026.061.024.136-.016.134-.032.134",
    "data-name": "Path 16336"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.522 68.43c-.016 0-.027-.061-.025-.135s.016-.135.032-.134.027.061.025.135-.016.135-.032.134",
    "data-name": "Path 16337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.505 68.97c-.016 0-.027-.061-.025-.135s.016-.135.032-.134.027.061.025.135-.016.135-.032.134",
    "data-name": "Path 16338"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.491 69.509c-.016 0-.027-.061-.025-.136s.016-.134.032-.134.027.061.025.135-.016.135-.032.134",
    "data-name": "Path 16339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.478 70.051c-.016 0-.027-.061-.025-.136s.016-.134.032-.134.027.061.025.135-.016.135-.032.134",
    "data-name": "Path 16340"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.464 70.589c-.016 0-.027-.061-.025-.136s.016-.134.031-.134.027.061.025.135-.016.135-.032.134",
    "data-name": "Path 16341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.452 71.129c-.016 0-.027-.061-.025-.136s.016-.134.031-.134.027.061.025.135-.016.135-.032.134",
    "data-name": "Path 16342"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.439 71.669c-.016 0-.027-.061-.025-.136s.016-.134.032-.134.027.061.025.135-.016.135-.031.134",
    "data-name": "Path 16343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.427 72.209c-.016 0-.027-.061-.025-.136s.016-.134.032-.134.027.061.025.136-.016.135-.031.134",
    "data-name": "Path 16344"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.415 72.749c-.016 0-.027-.061-.025-.136s.016-.134.031-.134.027.061.025.136-.016.135-.031.134",
    "data-name": "Path 16345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.403 73.29c-.016 0-.027-.061-.025-.136s.016-.134.031-.134.027.061.025.136-.016.135-.031.134",
    "data-name": "Path 16346"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.391 73.829c-.016 0-.027-.061-.025-.136s.016-.134.031-.134.027.061.025.136-.016.135-.031.134",
    "data-name": "Path 16347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.38 74.369c-.016 0-.027-.061-.025-.136s.016-.134.031-.134.027.061.025.136-.016.135-.031.134",
    "data-name": "Path 16348"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.368 74.909c-.016 0-.027-.061-.025-.136s.015-.135.031-.134.027.061.025.136-.016.135-.031.134",
    "data-name": "Path 16349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.357 75.45c-.016 0-.027-.061-.025-.136s.015-.134.031-.134.027.061.026.136-.016.135-.031.134",
    "data-name": "Path 16350"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.346 75.99c-.016 0-.027-.061-.025-.135s.015-.134.031-.134.027.061.026.135-.016.135-.031.134",
    "data-name": "Path 16351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.336 76.527c-.016 0-.027-.061-.026-.136s.016-.135.031-.134.027.061.026.136-.016.135-.031.134",
    "data-name": "Path 16352"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.327 77.071c-.016 0-.027-.061-.026-.136s.016-.135.031-.134.027.061.025.136-.015.135-.031.134",
    "data-name": "Path 16353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.315 77.612c-.016 0-.027-.061-.026-.136s.016-.135.031-.134.027.061.025.136-.015.135-.031.134",
    "data-name": "Path 16354"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.304 78.152c-.016 0-.027-.061-.026-.136s.016-.135.031-.134.027.061.025.136-.015.135-.031.134",
    "data-name": "Path 16355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.294 78.693c-.016 0-.027-.061-.026-.136s.016-.135.031-.134.027.061.025.136-.015.135-.031.134",
    "data-name": "Path 16356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.283 79.233c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.025.136-.015.135-.031.134",
    "data-name": "Path 16357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.274 79.774c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.264 80.314c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.253 80.855c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16360"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.243 81.395c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.233 81.936c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.223 82.474c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.213 83.017c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.204 83.557c-.016 0-.028-.061-.026-.136s.015-.135.03-.134.027.061.026.136-.016.135-.031.134",
    "data-name": "Path 16365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.194 84.098c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.184 84.638c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16367"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.174 85.179c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.163 85.719c-.016 0-.027-.061-.026-.136s.015-.135.031-.134.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16369"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.154 86.26c-.016 0-.027-.061-.026-.135s.015-.135.031-.135.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16370"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.144 86.8c-.016 0-.027-.061-.026-.135s.015-.135.031-.135.027.061.026.136-.015.135-.031.134",
    "data-name": "Path 16371"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.13 87.341c-.016 0-.027-.061-.026-.136s.015-.134.031-.134.027.061.025.136-.015.135-.031.134",
    "data-name": "Path 16372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.123 87.881c-.016 0-.027-.061-.026-.135s.016-.135.031-.135.027.061.025.136-.015.135-.031.134",
    "data-name": "Path 16373"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.112 88.423c-.016 0-.027-.061-.026-.135s.016-.135.031-.135.027.061.025.136-.015.135-.031.134",
    "data-name": "Path 16374"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.102 88.962c-.016 0-.027-.061-.026-.135s.016-.135.031-.135.027.061.025.136-.015.135-.031.134",
    "data-name": "Path 16375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.092 89.502c-.016 0-.027-.061-.026-.135s.016-.135.031-.135.027.061.025.136-.015.135-.031.134",
    "data-name": "Path 16376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.08 90.042c-.016 0-.027-.061-.025-.135s.015-.135.031-.135.027.061.026.136-.016.135-.031.134",
    "data-name": "Path 16377"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.069 90.582c-.016 0-.027-.061-.025-.135s.015-.135.031-.135.027.061.026.136-.016.135-.031.134",
    "data-name": "Path 16378"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.058 91.122c-.016 0-.027-.061-.025-.135s.015-.135.031-.134.027.061.026.135-.016.135-.031.134",
    "data-name": "Path 16379"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.047 91.66c-.016 0-.027-.061-.025-.135s.016-.135.031-.134.027.061.025.135-.016.135-.031.134",
    "data-name": "Path 16380"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.033 92.202c-.016 0-.027-.061-.025-.135s.016-.135.031-.134.027.061.025.135-.016.135-.031.134",
    "data-name": "Path 16381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.024 92.742c-.016 0-.027-.061-.025-.135s.016-.135.031-.134.027.061.025.135-.016.135-.031.134",
    "data-name": "Path 16382"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127.012 93.281c-.016 0-.027-.061-.025-.135s.016-.135.031-.134.027.061.025.135-.016.135-.031.134",
    "data-name": "Path 16383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M127 93.822c-.016 0-.027-.061-.025-.135s.016-.135.031-.134.027.061.025.135-.016.135-.031.134",
    "data-name": "Path 16384"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.988 94.361c-.016 0-.027-.061-.025-.135s.016-.135.032-.134.027.061.025.135-.016.135-.031.134",
    "data-name": "Path 16385"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.975 94.901c-.016 0-.027-.061-.025-.135s.016-.135.032-.134.027.061.025.135-.016.135-.031.134",
    "data-name": "Path 16386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.963 95.44c-.016 0-.027-.061-.025-.135s.016-.135.031-.134.027.061.025.135-.016.135-.032.134",
    "data-name": "Path 16387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.951 95.979c-.016 0-.027-.061-.025-.135s.016-.135.031-.134.027.061.025.136-.016.134-.032.134",
    "data-name": "Path 16388"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.937 96.518c-.016 0-.027-.061-.025-.135s.017-.134.032-.134.027.061.025.136-.016.134-.031.134",
    "data-name": "Path 16389"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.924 97.057c-.016 0-.027-.061-.025-.135s.016-.134.032-.134.027.061.025.136-.016.134-.032.134",
    "data-name": "Path 16390"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.911 97.596c-.016 0-.027-.061-.025-.135s.016-.134.032-.134.027.061.025.135-.016.134-.032.134",
    "data-name": "Path 16391"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.896 98.135c-.016 0-.027-.061-.025-.135s.016-.134.032-.134.027.061.025.135-.016.134-.032.134",
    "data-name": "Path 16392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.882 98.674c-.016 0-.027-.061-.025-.135s.017-.134.032-.134.027.061.024.135-.016.134-.032.134",
    "data-name": "Path 16393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M126.868 99.187c-.016 0-.027-.056-.025-.123s.016-.122.032-.121.027.056.025.123-.016.122-.032.121",
    "data-name": "Path 16394"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5baab",
    d: "M126.426 37.343a596 596 0 0 0-.177-2.926 2.01 2.01 0 0 1-1.872-1.764c-.176-1.661-.244-5.506-.244-5.506a5.91 5.91 0 0 1 5.917.165l.422.261.045 1.953-.1 1.756-.073 4.78-3.912 1.288a.01.01 0 0 1-.011-.006",
    "data-name": "Path 16395"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M124.391 29.813a.214.214 0 1 0 .2-.222.214.214 0 0 0-.2.222",
    "data-name": "Path 16396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M124.375 29.739c.029.027.181-.115.411-.137s.408.08.431.048c.011-.014-.019-.064-.1-.112a.57.57 0 0 0-.672.071c-.066.064-.086.118-.072.13",
    "data-name": "Path 16397"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M127.014 29.533a.213.213 0 0 0-.043.3.215.215 0 0 0 .3.043.213.213 0 0 0 .043-.3.215.215 0 0 0-.3-.043",
    "data-name": "Path 16398"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M126.931 29.627c.029.027.181-.115.411-.137s.408.08.431.048c.011-.014-.019-.064-.1-.112a.57.57 0 0 0-.672.071c-.067.064-.086.118-.072.13",
    "data-name": "Path 16399"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M126.186 31.601a1.2 1.2 0 0 1-.379.045.2.2 0 0 1-.213-.088.38.38 0 0 1 .01-.249l.129-.485a7 7 0 0 1 .4-1.227 7 7 0 0 1-.284 1.258l-.138.482a.3.3 0 0 0-.026.178c.009.034.06.043.12.044a1.2 1.2 0 0 1 .379.041",
    "data-name": "Path 16400"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.952 31.785a4.5 4.5 0 0 1-1.1.431.64.64 0 0 0 .774.182c.483-.229.324-.614.324-.614",
    "data-name": "Path 16401"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d78776",
    d: "M126.249 34.448a4.2 4.2 0 0 0 2.184-.843 2.16 2.16 0 0 1-2.129 1.25Z",
    "data-name": "Path 16402"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M129.593 26.169a6.7 6.7 0 0 0-1.541-.965 2.27 2.27 0 0 0-1.775-.027c-.254.119-.475.3-.736.4-.548.213-1.224.055-1.7.395a1.15 1.15 0 0 0-.277 1.447 1.73 1.73 0 0 0 1.316.825 3.5 3.5 0 0 0 1.585-.231 1.37 1.37 0 0 1 .92-.114c.282.108.477.417.778.443.262.023.571-.17.763.01a.5.5 0 0 1 .12.292c.1.573.443 1.731.547 2.3.377.163.555-.342.967-.351.067-1.267.614-2.539.294-3.767a1.3 1.3 0 0 0-.486-.78.644.644 0 0 0-.849.1",
    "data-name": "Path 16403"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5baab",
    d: "M129.851 29.271c.031-.02 1.12-.419 1.314.923s-1.232 1.095-1.24 1.056-.075-1.98-.075-1.98",
    "data-name": "Path 16404"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d78776",
    d: "M130.27 30.72c.005-.005.026.013.069.026a.24.24 0 0 0 .176-.022.58.58 0 0 0 .194-.558.8.8 0 0 0-.115-.325.27.27 0 0 0-.2-.154.12.12 0 0 0-.129.084c-.013.04 0 .066-.007.069s-.032-.018-.029-.075a.15.15 0 0 1 .041-.092.18.18 0 0 1 .125-.053.34.34 0 0 1 .276.173.8.8 0 0 1 .136.363.61.61 0 0 1-.258.629.26.26 0 0 1-.22 0c-.047-.028-.058-.057-.054-.059",
    "data-name": "Path 16405"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M129.304 25.272c.038-.009.119.2.183.475s.083.5.045.507-.12-.2-.183-.475-.083-.5-.045-.507",
    "data-name": "Path 16406"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M129.898 25.333c.036.016-.025.234-.135.487s-.228.446-.264.43.024-.234.135-.486.228-.446.264-.431",
    "data-name": "Path 16407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5baab",
    d: "M126.629 46.503a3 3 0 0 1-.479 1.06c-.768.836-7.415-6.355-7.415-6.355a7.7 7.7 0 0 1-.051-1.4 3.4 3.4 0 0 1 .286-.89.29.29 0 0 0-.319-.447 2.38 2.38 0 0 0-.787 1.685c-.111.921-1.089-.223-1.382-.667a8.7 8.7 0 0 0-1.517-1.8c-.306-.027-.338.348-.034.784a8 8 0 0 1 1.061 1.817c-.221.168-1.78-2.093-1.78-2.093s-.242-.469-.528-.313c-.517.281 1.216 2.583 1.386 2.8.118.15-.052.208-.171.04s-1.507-2.124-1.873-1.873 1.16 1.871 1.366 2.35c.233.543-1.244-1.427-1.624-1.205-.141.083-.235.164.659 1.218a37 37 0 0 0 2.869 2.73c1.886 2.234 8.415 9.667 11.469 9.249a2.25 2.25 0 0 0 1.677-1.044 23.4 23.4 0 0 0 2.076-3.99Z",
    "data-name": "Path 16408"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10018"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_insigts_svg__b)",
    "data-name": "Group 10017"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e8505b",
    d: "m54.777 100.765-.06-2.472-4.652.082.05 3.617.289.014a55 55 0 0 0 7.391-.119c.952-.306-3.016-1.122-3.016-1.122",
    "data-name": "Path 16409"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M51.784 101.933a1.6 1.6 0 0 0-.611-.977 1.57 1.57 0 0 0-1.093-.318l.022 1.294Z",
    "data-name": "Path 16410"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M56.717 101.232s1.393.373 1.224.6-5.48.321-7.827.157l.006-.1 6.2-.053s.13-.587.4-.6",
    "data-name": "Path 16411"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.047 101.888a.4.4 0 0 1 .08 0h1.076c.715 0 1.7 0 2.791-.015s2.077-.049 2.791-.076l.845-.032.23-.007a.04.04 0 1 1 0 .012l-.229.017-.845.049a85.794 85.794 0 0 1-5.585.092l-.846-.022-.23-.01a.4.4 0 0 1-.08-.007",
    "data-name": "Path 16412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M56.316 101.909a.75.75 0 0 1 .434-.732 1.22 1.22 0 0 0-.434.732",
    "data-name": "Path 16413"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M54.931 101.237c-.013-.008.03-.1.1-.209s.13-.188.143-.18-.029.1-.1.209-.131.189-.144.18",
    "data-name": "Path 16414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M54.547 101.046c-.011-.012.045-.08.124-.153s.151-.123.162-.112-.045.08-.123.153-.152.123-.162.112",
    "data-name": "Path 16415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M54.306 100.612a.56.56 0 0 1 .243-.029.55.55 0 0 1 .243.027.55.55 0 0 1-.243.029.55.55 0 0 1-.243-.027",
    "data-name": "Path 16416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M54.219 100.306a19 19 0 0 0 .551.032.48.48 0 0 1-.279.042.47.47 0 0 1-.272-.074",
    "data-name": "Path 16417"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M55.084 100.832c0-.009.114-.012.292-.046a2 2 0 0 0 .306-.085 1 1 0 0 0 .167-.074c.052-.032.07-.088.022-.122a.47.47 0 0 0-.357-.018.54.54 0 0 0-.252.17.9.9 0 0 0-.132.256s0-.029.006-.08a.5.5 0 0 1 .094-.2.55.55 0 0 1 .675-.171.12.12 0 0 1 .048.118.16.16 0 0 1-.073.094 1 1 0 0 1-.181.078 2 2 0 0 1-.317.075.9.9 0 0 1-.3.007",
    "data-name": "Path 16418"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M55.16 100.844a1 1 0 0 0-.008-.2.5.5 0 0 0-.088-.192c-.047-.059-.124-.132-.2-.123s-.045.127 0 .19a1 1 0 0 0 .128.176c.084.093.15.138.144.145a.43.43 0 0 1-.173-.117 1 1 0 0 1-.144-.178.3.3 0 0 1-.053-.132.12.12 0 0 1 .09-.139.3.3 0 0 1 .252.147.5.5 0 0 1 .085.216.3.3 0 0 1-.031.207",
    "data-name": "Path 16419"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.12 100.618a.3.3 0 0 1 .091-.023 1.2 1.2 0 0 1 .256-.011 1.41 1.41 0 0 1 1.27.972 1.2 1.2 0 0 1 .055.249.3.3 0 0 1 0 .093c-.01 0-.019-.132-.094-.329a1.46 1.46 0 0 0-1.235-.946c-.211-.021-.342 0-.344-.006",
    "data-name": "Path 16420"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.569 98.683a16 16 0 0 1 .009 1.9 16 16 0 0 1-.009-1.9",
    "data-name": "Path 16421"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.378 101.465c0-.016.306 0 .68 0s.678-.026.68-.01a3.8 3.8 0 0 1-1.36.01",
    "data-name": "Path 16422"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.466 101.479c.01-.012.071.029.109.108s.03.153.015.153-.033-.06-.066-.129-.069-.121-.058-.132",
    "data-name": "Path 16423"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.116 101.059c.011-.011.059.019.108.066s.08.1.069.107-.059-.019-.108-.067-.08-.1-.069-.106",
    "data-name": "Path 16424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.621 100.872c0-.014.066-.044.151-.016s.126.092.114.1-.061-.026-.131-.047-.131-.021-.134-.037",
    "data-name": "Path 16425"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.269 100.787c.005-.015.041-.015.08 0s.066.038.061.052-.041.015-.08 0-.066-.038-.061-.052",
    "data-name": "Path 16426"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5baab",
    d: "M71.072 31.42s3.971-4.082 4.331-3.9-1.457 1.842-1.216 2.057 2.154 1.664-.926 3.959Z",
    "data-name": "Path 16427"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d78776",
    d: "M74.49 30.238a.6.6 0 0 1-.064.12l-.192.316-.291.466a.67.67 0 0 1-.234.239.3.3 0 0 1-.356-.051.315.315 0 0 1 .023-.356c.06-.1.12-.186.176-.274l.3-.459.207-.307a.7.7 0 0 1 .082-.108.6.6 0 0 1-.064.12l-.192.316-.291.465-.171.273c-.053.091-.1.211-.028.294a.24.24 0 0 0 .287.038.6.6 0 0 0 .215-.219l.3-.458.207-.307a.6.6 0 0 1 .083-.108",
    "data-name": "Path 16428"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d78776",
    d: "M74.692 30.684a.4.4 0 0 1-.016.117 1.5 1.5 0 0 1-.1.3 1.7 1.7 0 0 1-.256.4.7.7 0 0 1-.219.187.25.25 0 0 1-.31-.029.3.3 0 0 1-.04-.31 1 1 0 0 1 .149-.243c.1-.144.183-.281.255-.395s.132-.205.176-.266a.4.4 0 0 1 .075-.09.5.5 0 0 1-.057.1l-.16.274c-.067.117-.145.257-.247.4a1.1 1.1 0 0 0-.139.232.25.25 0 0 0 .03.254.2.2 0 0 0 .243.018.7.7 0 0 0 .2-.172 1.8 1.8 0 0 0 .259-.385 4 4 0 0 0 .153-.4",
    "data-name": "Path 16429"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5baab",
    d: "m72.3 30.579 1.454-.1a.2.2 0 0 1 .08.005c.077.028.09.132.071.212a.8.8 0 0 1-.506.528 2.4 2.4 0 0 1-.748.126l-.7.042",
    "data-name": "Path 16430"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d78776",
    d: "M71.954 31.395a1 1 0 0 1 .156-.02l.427-.035a5 5 0 0 0 .628-.07.98.98 0 0 0 .628-.386c.068-.107.124-.252.065-.344-.027-.044-.089-.031-.154-.028l-.184.012-.635.036-.429.02a1 1 0 0 1-.157 0 1 1 0 0 1 .156-.022l.427-.038.634-.048.184-.014c.032 0 .061-.006.1 0a.14.14 0 0 1 .1.053.26.26 0 0 1 .024.214.7.7 0 0 1-.086.194 1.02 1.02 0 0 1-.665.406 4 4 0 0 1-.637.059l-.428.017a1 1 0 0 1-.158 0",
    "data-name": "Path 16431"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d78776",
    d: "M74.937 31.083a.5.5 0 0 1-.033.087 2 2 0 0 0-.074.239 1.3 1.3 0 0 1-.136.354.5.5 0 0 1-.162.166.2.2 0 0 1-.13.031.17.17 0 0 1-.116-.078.28.28 0 0 1-.016-.252c.027-.075.06-.14.088-.2l.156-.34a2 2 0 0 1 .156-.307 2 2 0 0 1-.12.323l-.145.345c-.046.126-.153.279-.073.405a.115.115 0 0 0 .17.03.5.5 0 0 0 .146-.146 1.4 1.4 0 0 0 .141-.338.8.8 0 0 1 .145-.314",
    "data-name": "Path 16432"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d78776",
    d: "M73.097 32.552c-.017 0 .06-.274.081-.615s-.019-.618 0-.62a2 2 0 0 1-.079 1.236",
    "data-name": "Path 16433"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M54.22 30.06a3.08 3.08 0 0 0 1.472 2.618 7 7 0 0 1 .73.432.91.91 0 0 1 .392.715c-.018.44-.466.72-.86.92a1.133 1.133 0 0 1 .01 1.583 1.145 1.145 0 0 1-1.589-.073 2.01 2.01 0 0 1-1.482 1.783 2.83 2.83 0 0 1-2.357-.481 4.7 4.7 0 0 1-1.5-1.94",
    "data-name": "Path 16434"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5baab",
    d: "M52.21 37.765a17 17 0 0 1 .1-2.168 1.91 1.91 0 0 0 1.7-1.755c.1-1.585 0-5.241 0-5.241l-2.925-1.423-3.216 2.427.487 7.926Z",
    "data-name": "Path 16435"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M53.693 31.265a.2.2 0 1 1-.2-.2.2.2 0 0 1 .2.2",
    "data-name": "Path 16436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M53.89 31.045c-.026.026-.177-.1-.4-.113s-.384.094-.407.064c-.011-.013.016-.061.088-.111a.545.545 0 0 1 .642.039c.066.058.086.109.074.12",
    "data-name": "Path 16437"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M51.331 31.265a.2.2 0 1 1-.2-.2.2.2 0 0 1 .2.2",
    "data-name": "Path 16438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M51.457 31.045c-.026.026-.177-.1-.4-.113s-.384.094-.407.064c-.011-.013.016-.061.088-.111a.545.545 0 0 1 .642.039c.066.058.086.109.074.12",
    "data-name": "Path 16439"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M52.249 32.875a1.5 1.5 0 0 1 .357-.043c.055 0 .113-.01.126-.051a.3.3 0 0 0-.03-.176l-.151-.45c-.1-.32-.195-.611-.256-.823a1.5 1.5 0 0 1-.082-.349 1.5 1.5 0 0 1 .139.33c.076.207.175.5.28.816l.144.452a.33.33 0 0 1 .02.227.18.18 0 0 1-.187.083 1.5 1.5 0 0 1-.359-.016",
    "data-name": "Path 16440"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.524 33.097a4.3 4.3 0 0 0 1.061.364.61.61 0 0 1-.728.205c-.469-.2-.334-.569-.334-.569",
    "data-name": "Path 16441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d78776",
    d: "M52.308 35.596a4 4 0 0 1-2.11-.709 2.06 2.06 0 0 0 2.075 1.1Z",
    "data-name": "Path 16442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M53.341 27.436a3.46 3.46 0 0 0-3.282-1.294 4.98 4.98 0 0 0-3.45 1.985 6.85 6.85 0 0 0-1.141 2.466 12 12 0 0 0 .015 1.586 1.92 1.92 0 0 1-.523 1.45c-.252.222-.606.351-.758.65a.836.836 0 0 0 .35 1.016 1.9 1.9 0 0 0 1.137.233 1.6 1.6 0 0 0 1.3 1.7 1.56 1.56 0 0 0 1.141-.3 9 9 0 0 0 .848.727q.1-3.461-.146-6.92c1.063-.188 2.969-.758 3.3-2.453a6.1 6.1 0 0 0 1.925 2.222 2.55 2.55 0 0 0-.714-3.07",
    "data-name": "Path 16443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M48.947 30.124a2.7 2.7 0 0 1 .651 0 3.4 3.4 0 0 0 1.511-.176 1.4 1.4 0 0 0 .63-.509 1.7 1.7 0 0 0 .253-.625c.074-.384.038-.634.063-.636a1.3 1.3 0 0 1 .035.652 1.7 1.7 0 0 1-.242.679 1.5 1.5 0 0 1-.683.567 3.1 3.1 0 0 1-1.575.146 3.4 3.4 0 0 1-.644-.1",
    "data-name": "Path 16444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M44.799 34.006a1 1 0 0 0 .26-.037.7.7 0 0 0 .432-.514 1.73 1.73 0 0 0-.194-1.026 4 4 0 0 1-.226-.617 2.1 2.1 0 0 1-.044-.714 2.9 2.9 0 0 1 .475-1.277 5 5 0 0 1 .719-.844c.228-.217.424-.379.56-.489a1 1 0 0 1 .222-.159c.016.017-.275.275-.712.718a5.3 5.3 0 0 0-.68.843 2.9 2.9 0 0 0-.444 1.222 2 2 0 0 0 .038.667 4 4 0 0 0 .212.6 1.77 1.77 0 0 1 .171 1.1.75.75 0 0 1-.512.542.5.5 0 0 1-.209.01c-.047-.01-.069-.021-.068-.025",
    "data-name": "Path 16445"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M56.369 31.744c.006 0 .051.059.05.19a.6.6 0 0 1-.272.464.82.82 0 0 1-.8.01 1.7 1.7 0 0 1-.674-.7 4.3 4.3 0 0 1-.559-1.638 2.1 2.1 0 0 1-.01-.716c.023 0 .03.272.109.7a4.8 4.8 0 0 0 .581 1.582 1.63 1.63 0 0 0 .61.657.73.73 0 0 0 .688.022.56.56 0 0 0 .27-.385c.018-.116-.007-.182 0-.186",
    "data-name": "Path 16446"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M53.904 56.671s5.427 17.533 5.085 23.2-4.316 19.722-4.316 19.722Z",
    "data-name": "Path 16447"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M46.24 53.684a12.8 12.8 0 0 0-2.58 6.441 8 8 0 0 0 .034.88 11 11 0 0 0 .749 3.051c2.012 5.058 4.088 11.057 4.122 12.422.106 4.21.931 23.563.931 23.563l5.849-.411-.192-23.151-1.425-22.987Z",
    "data-name": "Path 16448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.435 53.585a12.4 12.4 0 0 1 .051 1.82c.012 1.174-.055 2.875.023 4.973.023.524.041 1.074.088 1.645s.089 1.166.152 1.78c.128 1.228.305 2.535.525 3.906s.468 2.808.679 4.3.377 3.055.464 4.655.075 3.168.1 4.678.058 2.969.1 4.357c.082 2.776.181 5.275.262 7.373s.14 3.79.184 4.971l.042 1.352c.01.316.01.471.01.471l-.275-6.793c-.086-2.1-.189-4.6-.274-7.373-.042-1.388-.078-2.846-.1-4.357s-.009-3.077-.105-4.676-.252-3.155-.463-4.651-.458-2.932-.675-4.3-.394-2.68-.52-3.909c-.062-.615-.115-1.209-.149-1.781s-.062-1.122-.084-1.647c-.073-2.1 0-3.8 0-4.975v-1.352a2 2 0 0 0-.027-.467",
    "data-name": "Path 16449"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.463 99.208h5.88v.882h-5.88z",
    "data-name": "Rectangle 3127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.833 53.762c-.016 0-.03-.059-.032-.134s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16450"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.849 54.301c-.016 0-.03-.059-.032-.134s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16451"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.865 54.839c-.016 0-.03-.059-.032-.133s.009-.135.024-.136.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16452"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.881 55.378c-.016 0-.03-.059-.032-.134s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.897 55.917c-.016 0-.03-.059-.032-.134s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16454"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.912 56.456c-.016 0-.031-.059-.033-.134s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16455"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.928 56.997c-.016 0-.03-.059-.032-.134s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16456"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.944 57.533c-.016 0-.03-.059-.032-.134s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16457"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.96 58.071c-.016 0-.03-.059-.032-.134s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16458"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.976 58.61c-.016 0-.03-.059-.032-.134s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16459"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.991 59.149c-.016 0-.03-.059-.032-.134s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16460"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M49.994 59.689c-.016 0-.029-.06-.029-.135s.012-.135.027-.135.029.06.029.134-.012.135-.027.135",
    "data-name": "Path 16461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.001 60.229c-.016 0-.029-.06-.03-.134s.01-.135.026-.135.029.06.031.134-.011.135-.026.135",
    "data-name": "Path 16462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.013 60.766c-.016 0-.03-.06-.032-.134s.009-.135.025-.135.03.059.032.134-.009.135-.025.136",
    "data-name": "Path 16463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.032 61.308c-.016 0-.03-.059-.033-.134s.008-.135.023-.136.031.059.033.134-.008.135-.023.136",
    "data-name": "Path 16464"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.055 61.847c-.016 0-.031-.059-.034-.133s.007-.135.022-.136.031.059.034.133-.006.135-.022.136",
    "data-name": "Path 16465"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.083 62.385c-.016 0-.032-.059-.036-.133s.005-.135.021-.136.032.059.035.133 0 .135-.02.136",
    "data-name": "Path 16466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.118 62.924c-.016 0-.032-.059-.037-.132s0-.135.019-.137.033.058.037.133 0 .135-.019.136",
    "data-name": "Path 16467"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.159 63.462c-.016 0-.033-.058-.039-.132s0-.135.017-.137.033.059.039.132 0 .135-.017.136",
    "data-name": "Path 16468"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.207 63.998c-.016 0-.034-.058-.04-.132s0-.135.016-.137.034.058.04.132 0 .135-.016.137",
    "data-name": "Path 16469"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.26 64.54c-.016 0-.034-.057-.042-.131s0-.135.015-.137.034.058.042.132 0 .135-.015.137",
    "data-name": "Path 16470"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.318 65.067c-.016 0-.035-.057-.043-.131s0-.135.013-.137.034.057.043.131 0 .135-.013.137",
    "data-name": "Path 16471"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.384 65.605c-.016 0-.036-.057-.045-.13s0-.135.012-.137.035.057.044.13 0 .135-.011.137",
    "data-name": "Path 16472"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.453 66.139c-.016 0-.036-.056-.046-.13s-.005-.135.01-.137.036.056.046.13.005.135-.01.137",
    "data-name": "Path 16473"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.529 66.671c-.016 0-.036-.056-.047-.129s-.006-.134.009-.137.036.056.047.129.007.134-.009.137",
    "data-name": "Path 16474"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.609 67.202c-.016 0-.037-.056-.048-.129s-.008-.135.007-.137.037.056.049.129.008.135-.008.137",
    "data-name": "Path 16475"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.691 67.735c-.016 0-.037-.055-.05-.129s-.008-.135.007-.137.038.055.05.129.009.135-.007.137",
    "data-name": "Path 16476"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.779 68.265c-.016 0-.038-.055-.05-.128s-.01-.135.006-.137.037.055.05.128.01.135-.006.137",
    "data-name": "Path 16477"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.868 68.796c-.016 0-.038-.055-.05-.128s-.01-.134.005-.137.038.055.05.128.01.135-.005.137",
    "data-name": "Path 16478"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M50.959 69.326c-.016 0-.038-.055-.051-.128s-.01-.135.005-.137.038.055.051.128.01.135-.005.137",
    "data-name": "Path 16479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.05 69.852c-.016 0-.038-.055-.051-.128s-.01-.134.005-.137.038.055.051.128.01.135-.005.137",
    "data-name": "Path 16480"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.139 70.386c-.016 0-.038-.055-.05-.128s-.01-.135.005-.137.038.055.05.128.01.134-.005.137",
    "data-name": "Path 16481"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.226 70.92c-.016 0-.037-.055-.05-.128s-.009-.134.006-.137.038.055.05.128.01.134-.006.137",
    "data-name": "Path 16482"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.313 71.446c-.016 0-.037-.055-.049-.128s-.008-.135.007-.137.037.055.049.129.009.134-.007.137",
    "data-name": "Path 16483"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.394 71.977c-.016 0-.037-.055-.048-.129s-.008-.135.008-.137.037.055.048.129.008.134-.008.137",
    "data-name": "Path 16484"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.471 72.508c-.016 0-.036-.055-.047-.129s-.006-.135.009-.137.036.056.047.129.007.135-.009.136",
    "data-name": "Path 16485"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.543 73.041c-.016 0-.036-.056-.046-.13s-.005-.135.01-.137.036.056.046.13.005.135-.01.137",
    "data-name": "Path 16486"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.612 73.575c-.016 0-.035-.057-.044-.13s0-.135.012-.137.035.056.044.13 0 .135-.012.137",
    "data-name": "Path 16487"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.671 74.111c-.016 0-.034-.057-.043-.131s0-.135.013-.137.034.057.043.131 0 .135-.013.137",
    "data-name": "Path 16488"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.726 74.639c-.016 0-.034-.057-.041-.131s0-.135.015-.137.034.057.041.131 0 .135-.015.137",
    "data-name": "Path 16489"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.775 75.18c-.016 0-.034-.058-.04-.132s0-.135.016-.137.034.058.04.132 0 .135-.016.136",
    "data-name": "Path 16490"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.817 75.717c-.016 0-.033-.058-.038-.132s0-.135.018-.136.033.058.038.132 0 .135-.018.136",
    "data-name": "Path 16491"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.854 76.255c-.016 0-.032-.059-.037-.132s0-.135.019-.136.032.059.037.132 0 .135-.019.136",
    "data-name": "Path 16492"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.885 76.79c-.016 0-.032-.059-.035-.132s.005-.134.021-.135.032.059.035.132-.005.134-.021.135",
    "data-name": "Path 16493"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.908 77.327c-.016 0-.031-.059-.034-.133s.007-.135.022-.135.031.059.034.133-.007.135-.022.135",
    "data-name": "Path 16494"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.927 77.865c-.016 0-.03-.059-.033-.133s.008-.135.024-.135.03.059.033.133-.008.135-.024.135",
    "data-name": "Path 16495"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.943 78.403c-.016 0-.03-.059-.031-.134s.01-.135.025-.135.029.059.031.134-.01.135-.025.135",
    "data-name": "Path 16496"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.949 78.942c-.016 0-.029-.06-.03-.134s.011-.135.026-.135.029.06.03.134-.011.135-.027.135",
    "data-name": "Path 16497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.953 79.481c-.016 0-.029-.06-.029-.134s.012-.135.027-.135.029.06.029.134-.012.135-.027.135",
    "data-name": "Path 16498"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.958 80.02c-.016 0-.029-.06-.03-.134s.012-.135.027-.135.029.06.029.134-.011.135-.027.135",
    "data-name": "Path 16499"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.964 80.559c-.016 0-.029-.06-.03-.134s.011-.135.026-.135.029.06.03.134-.011.135-.027.135",
    "data-name": "Path 16500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.971 81.097c-.016 0-.029-.06-.03-.134s.011-.135.026-.135.029.06.03.134-.011.135-.026.135",
    "data-name": "Path 16501"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.98 81.636c-.016 0-.029-.06-.031-.134s.011-.135.026-.135.029.06.031.134-.011.135-.026.135",
    "data-name": "Path 16502"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M51.991 82.175c-.016 0-.029-.06-.031-.134s.01-.135.026-.135.029.059.031.134-.01.135-.026.135",
    "data-name": "Path 16503"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52 82.714c-.016 0-.03-.06-.031-.134s.01-.135.026-.135.029.059.031.134-.01.135-.025.135",
    "data-name": "Path 16504"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.012 83.253c-.016 0-.03-.06-.031-.134s.01-.135.025-.135.029.059.031.134-.01.135-.025.135",
    "data-name": "Path 16505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.024 83.791c-.016 0-.03-.059-.032-.134s.01-.135.025-.135.03.059.031.134-.009.135-.025.135",
    "data-name": "Path 16506"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.041 84.33c-.016 0-.03-.059-.032-.134s.009-.135.025-.135.03.059.032.134-.009.135-.025.135",
    "data-name": "Path 16507"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.053 84.868c-.016 0-.03-.059-.032-.134s.009-.135.025-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.068 85.408c-.016 0-.03-.059-.032-.133s.009-.135.024-.135.03.059.032.134-.009.135-.024.135",
    "data-name": "Path 16509"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.084 85.946c-.016 0-.03-.059-.032-.134s.008-.135.024-.135.03.059.033.134-.009.135-.024.135",
    "data-name": "Path 16510"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.1 86.485c-.016 0-.03-.059-.033-.134s.008-.135.024-.135.03.059.032.134-.008.135-.024.135",
    "data-name": "Path 16511"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.118 87.023c-.016 0-.03-.059-.033-.134s.008-.135.024-.135.03.059.033.134-.008.135-.024.135",
    "data-name": "Path 16512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.138 87.562c-.016 0-.031-.059-.033-.134s.008-.135.023-.135.031.059.033.134-.008.135-.023.135",
    "data-name": "Path 16513"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.155 88.101c-.016 0-.03-.059-.033-.133s.008-.135.024-.136.03.059.033.134-.008.135-.023.135",
    "data-name": "Path 16514"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.174 88.639c-.016 0-.03-.059-.033-.133s.008-.135.023-.136.031.059.033.134-.008.135-.023.135",
    "data-name": "Path 16515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.194 89.177c-.016 0-.031-.059-.033-.133s.008-.135.023-.136.03.059.033.133-.008.135-.023.136",
    "data-name": "Path 16516"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.214 89.716c-.016 0-.031-.059-.033-.133s.007-.135.023-.136.031.059.034.133-.008.135-.023.136",
    "data-name": "Path 16517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.235 90.254c-.016 0-.031-.059-.034-.133s.008-.135.023-.136.031.059.033.133-.007.135-.023.136",
    "data-name": "Path 16518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.255 90.793c-.016 0-.031-.059-.034-.133s.008-.135.023-.136.03.059.033.133-.007.135-.023.136",
    "data-name": "Path 16519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.276 91.331c-.016 0-.031-.059-.034-.133s.007-.135.023-.136.031.059.034.133-.007.135-.023.136",
    "data-name": "Path 16520"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.297 91.87c-.016 0-.031-.059-.034-.133s.007-.135.023-.136.031.059.034.133-.007.135-.023.136",
    "data-name": "Path 16521"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.319 92.408c-.016 0-.031-.059-.034-.133s.007-.135.023-.136.031.059.034.133-.007.135-.023.136",
    "data-name": "Path 16522"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.34 92.947c-.016 0-.031-.059-.034-.133s.007-.135.023-.136.031.059.034.133-.007.135-.023.136",
    "data-name": "Path 16523"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.362 93.485c-.016 0-.031-.059-.034-.133s.007-.135.022-.136.031.059.034.133-.007.135-.022.136",
    "data-name": "Path 16524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.383 94.024c-.016 0-.031-.059-.034-.133s.007-.135.023-.136.031.059.034.133-.007.135-.023.136",
    "data-name": "Path 16525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.405 94.561c-.016 0-.031-.059-.034-.133s.007-.135.023-.136.031.059.034.133-.007.135-.023.136",
    "data-name": "Path 16526"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.426 95.1c-.016 0-.031-.059-.034-.133s.007-.135.023-.136.031.059.034.133-.007.135-.023.136",
    "data-name": "Path 16527"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.447 95.639c-.016 0-.031-.059-.034-.133s.007-.135.023-.136.031.059.034.133-.007.135-.023.136",
    "data-name": "Path 16528"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.468 96.177c-.016 0-.031-.059-.034-.133s.008-.135.023-.136.03.059.033.133-.007.135-.022.136",
    "data-name": "Path 16529"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.489 96.716c-.016 0-.031-.059-.034-.133s.008-.135.023-.136.031.059.033.133-.007.135-.023.136",
    "data-name": "Path 16530"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.509 97.254c-.016 0-.031-.059-.033-.133s.007-.135.023-.136.031.059.034.133-.008.135-.023.136",
    "data-name": "Path 16531"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.529 97.793c-.016 0-.031-.059-.033-.133s.008-.135.023-.136.03.059.033.133-.008.135-.023.136",
    "data-name": "Path 16532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.549 98.334c-.016 0-.031-.059-.033-.133s.008-.135.023-.136.031.059.033.133-.007.135-.023.136",
    "data-name": "Path 16533"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.567 98.872c-.016 0-.03-.059-.033-.134s.008-.136.024-.136.03.059.033.134-.008.135-.023.136",
    "data-name": "Path 16534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.585 99.412c-.016 0-.03-.059-.033-.134s.008-.135.023-.136.031.059.033.134-.008.135-.024.136",
    "data-name": "Path 16535"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M52.598 99.805c-.016 0-.029-.026-.03-.059s.011-.061.026-.061.029.026.03.059-.011.061-.026.061",
    "data-name": "Path 16536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M54.143 59.657a.28.28 0 0 1-.249.013.5.5 0 0 1-.238-.18.85.85 0 0 1-.127-.373c-.047-.578-.086-1.373-.136-2.253l-.115-2.253-.028-.683v-.186a.3.3 0 0 1 0-.065.3.3 0 0 1 .009.065c0 .058.01.118.016.185l.046.682.131 2.252c.05.86.087 1.636.12 2.251a.8.8 0 0 0 .113.36.47.47 0 0 0 .219.178.36.36 0 0 0 .242.007",
    "data-name": "Path 16537"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M44.407 63.793a1 1 0 0 0 .214-.064.84.84 0 0 0 .4-.438 2.1 2.1 0 0 0 .1-.891 9 9 0 0 0-.114-1.107 9.5 9.5 0 0 0-.521-1.914l.022.013-.638.1-.174.026a.2.2 0 0 1-.062 0 .3.3 0 0 1 .06-.016l.172-.036.634-.122h.016l.006.015a8.8 8.8 0 0 1 .647 3.034 2.1 2.1 0 0 1-.112.908.84.84 0 0 1-.426.442.46.46 0 0 1-.223.044",
    "data-name": "Path 16538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M44.708 60.19a5 5 0 0 1-1.045.233 2.6 2.6 0 0 1 .516-.144 2.6 2.6 0 0 1 .528-.089",
    "data-name": "Path 16539"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m74.027 33.647-3.033-2.473c-8.24 7.4-18.864 6.559-18.864 6.559v.018c-.475-.077-2.979-.476-3.806-.492a4.32 4.32 0 0 0-3.2.864l-.078.076c-.958.931-10.551 10.342-9.533 12.673 1.072 2.454 10.189 7.785 10.189 7.785l2.208-3.993s-.687-.449-1.628-1.082l7.445-.19.329-5.548a5.1 5.1 0 0 0 1.271-2.429 9.8 9.8 0 0 0-.9-3.08 34.6 34.6 0 0 0 19.6-8.689M41.033 49.539a48 48 0 0 1 3.716-4.2c.6 3.625 1.4 7.8 1.484 8.212-2.071-1.4-5.31-3.648-5.2-4.012",
    "data-name": "Path 16540"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.885 46.636s-.094.01-.274.01a3 3 0 0 1-.782-.094 1.46 1.46 0 0 1-.956-.759.88.88 0 0 1 0-.769.78.78 0 0 1 .718-.46.8.8 0 0 1 .683.635 1.19 1.19 0 0 1-.265.995 2.38 2.38 0 0 1-2.068.846 2.46 2.46 0 0 1-1.179-.4 1.85 1.85 0 0 1-.781-1.028 1.05 1.05 0 0 1 .037-.676.92.92 0 0 1 .5-.47.67.67 0 0 1 .688.086.75.75 0 0 1 .243.659 1.5 1.5 0 0 1-.236.665 2.2 2.2 0 0 1-.48.5 2.63 2.63 0 0 1-1.246.508 2.49 2.49 0 0 1-2.31-.847 1.3 1.3 0 0 1-.256-.552.98.98 0 0 1 .075-.588.72.72 0 0 1 .428-.387.8.8 0 0 1 .559.05.98.98 0 0 1 .578.84 1.26 1.26 0 0 1-.371.879 1.95 1.95 0 0 1-1.512.577 2.36 2.36 0 0 1-1.18-.379 2 2 0 0 1-.569-.54 1.5 1.5 0 0 1-.141-.234c.005 0 .048.082.155.224a2.1 2.1 0 0 0 .574.522 2.34 2.34 0 0 0 1.164.359 1.9 1.9 0 0 0 1.466-.57 1.2 1.2 0 0 0 .349-.837.91.91 0 0 0-.542-.777.72.72 0 0 0-.507-.044.65.65 0 0 0-.383.35.9.9 0 0 0-.067.543 1.2 1.2 0 0 0 .242.518 2.41 2.41 0 0 0 2.236.812 2.55 2.55 0 0 0 1.206-.493 2.1 2.1 0 0 0 .46-.482 1.4 1.4 0 0 0 .222-.626.66.66 0 0 0-.212-.588.59.59 0 0 0-.6-.073.84.84 0 0 0-.458.426.97.97 0 0 0-.033.621 1.77 1.77 0 0 0 .746.982 2.4 2.4 0 0 0 1.141.389 2.3 2.3 0 0 0 2.006-.811 1.13 1.13 0 0 0 .257-.936.74.74 0 0 0-.623-.591.73.73 0 0 0-.666.424.83.83 0 0 0-.007.725 1.42 1.42 0 0 0 .922.746 3 3 0 0 0 .773.109h.2a.4.4 0 0 1 .07 0",
    "data-name": "Path 16541"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.823 51.752s-.045.034-.134.092-.22.144-.393.249a3.4 3.4 0 0 1-.664.325 2.2 2.2 0 0 1-.975.086 1.84 1.84 0 0 1-1.1-.436 1 1 0 0 1-.3-.6.7.7 0 0 1 .274-.645.63.63 0 0 1 .356-.135.54.54 0 0 1 .37.13.76.76 0 0 1 .232.734 1.26 1.26 0 0 1-.444.67 2.5 2.5 0 0 1-.716.412 2.75 2.75 0 0 1-1.609.1 2 2 0 0 1-1.252-.812.76.76 0 0 1-.067-.7.7.7 0 0 1 .539-.392.43.43 0 0 1 .318.091.5.5 0 0 1 .169.268.69.69 0 0 1-.115.562 1.66 1.66 0 0 1-.8.555 2 2 0 0 1-.731.112 1.8 1.8 0 0 1-.462-.07 1 1 0 0 1-.153-.054 2.5 2.5 0 0 0 .616.091 2 2 0 0 0 .715-.123 1.63 1.63 0 0 0 .769-.544.63.63 0 0 0 .1-.512.39.39 0 0 0-.416-.306.63.63 0 0 0-.479.354.68.68 0 0 0 .068.629 1.92 1.92 0 0 0 1.2.772 2.7 2.7 0 0 0 1.559-.1 2.4 2.4 0 0 0 .692-.4 1.18 1.18 0 0 0 .418-.624.68.68 0 0 0-.2-.655.49.49 0 0 0-.626.006.63.63 0 0 0-.248.576.94.94 0 0 0 .279.554 1.8 1.8 0 0 0 1.056.426 2.2 2.2 0 0 0 .954-.072 3.4 3.4 0 0 0 .662-.308l.4-.235c.092-.053.143-.077.143-.077",
    "data-name": "Path 16542"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.901 37.38a1.1 1.1 0 0 1 .3.207 1.42 1.42 0 0 1 .446.878 1.5 1.5 0 0 1-.084.686 1.54 1.54 0 0 1-.471.641 1.7 1.7 0 0 1-.806.354 1.4 1.4 0 0 1-.471-.005.66.66 0 0 1-.432-.239.32.32 0 0 1-.047-.261.4.4 0 0 1 .152-.208.76.76 0 0 1 .459-.134 1.13 1.13 0 0 1 .8.355 1.2 1.2 0 0 1 .311.73 1.4 1.4 0 0 1-.12.681 1.67 1.67 0 0 1-.666.732 2 2 0 0 1-.242.123.4.4 0 0 1-.09.03c0-.008.119-.053.314-.18a1.7 1.7 0 0 0 .629-.728 1.4 1.4 0 0 0 .1-.652 1.12 1.12 0 0 0-.3-.682 1.05 1.05 0 0 0-.746-.326.7.7 0 0 0-.409.118.253.253 0 0 0-.086.355.58.58 0 0 0 .377.2 1.4 1.4 0 0 0 .444.006 1.6 1.6 0 0 0 .768-.333 1.412 1.412 0 0 0 .135-2.121c-.166-.162-.283-.222-.277-.231",
    "data-name": "Path 16543"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.855 36.422a.5.5 0 0 1 .133.163.44.44 0 0 1 .045.247.9.9 0 0 1-.11.311 3 3 0 0 1-.494.687 5.2 5.2 0 0 0-.666.772 2.9 2.9 0 0 0-.444 1.755 4.5 4.5 0 0 0 .14.754 1 1 0 0 1-.082-.191 2.6 2.6 0 0 1-.118-.557 2.86 2.86 0 0 1 .433-1.805 5 5 0 0 1 .681-.779 3.1 3.1 0 0 0 .5-.662.9.9 0 0 0 .116-.288.4.4 0 0 0-.029-.228c-.054-.118-.11-.172-.1-.177",
    "data-name": "Path 16544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.841 39.604a.9.9 0 0 1-.4.083 1.18 1.18 0 0 1-.972-.515 1.74 1.74 0 0 1-.054-1.625 1.95 1.95 0 0 1 .6-.79 1.18 1.18 0 0 1 1.034-.211.815.815 0 0 1 .6.829.64.64 0 0 1-.226.466.75.75 0 0 1-.468.171 1.17 1.17 0 0 1-.835-.322 1.5 1.5 0 0 1-.405-.667 1.6 1.6 0 0 1 .068-1.109 1.1 1.1 0 0 1 .231-.341 2.4 2.4 0 0 0-.2.354 1.6 1.6 0 0 0-.041 1.079 1.44 1.44 0 0 0 .4.633 1.1 1.1 0 0 0 .784.3.68.68 0 0 0 .419-.154.56.56 0 0 0 .2-.41.74.74 0 0 0-.546-.744 1.1 1.1 0 0 0-.961.2 1.9 1.9 0 0 0-.577.754 1.69 1.69 0 0 0 .034 1.562 1.15 1.15 0 0 0 .923.514 1.6 1.6 0 0 0 .4-.05",
    "data-name": "Path 16545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.985 34.159a.7.7 0 0 1 .165.067 2.2 2.2 0 0 1 .407.267 2.1 2.1 0 0 1 .465.555 2.7 2.7 0 0 1 .307.829 2.6 2.6 0 0 1-.181 1.576 2.3 2.3 0 0 1-.242.421.6.6 0 0 1-.117.135 5 5 0 0 0 .3-.579 2.7 2.7 0 0 0 .153-1.536 2.8 2.8 0 0 0-.291-.807 2.1 2.1 0 0 0-.437-.548 5 5 0 0 0-.533-.38",
    "data-name": "Path 16546"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.418 35.785a1 1 0 0 1-.345.08 1.2 1.2 0 0 1-.417-.038 1 1 0 0 1-.468-.3 1.65 1.65 0 0 1-.414-1.342 1.04 1.04 0 0 1 .437-.725.84.84 0 0 1 .439-.146.68.68 0 0 1 .452.154.64.64 0 0 1 .24.412.6.6 0 0 1-.137.443.9.9 0 0 1-.794.289 1.6 1.6 0 0 1-1.193-.743.87.87 0 0 1-.159-.528 1.2 1.2 0 0 1 .112-.4c.047-.1.086-.182.113-.235a.046.046 0 1 1 .016.007l-.1.24a1.2 1.2 0 0 0-.1.391.83.83 0 0 0 .163.494 1.56 1.56 0 0 0 1.15.7.82.82 0 0 0 .722-.263.5.5 0 0 0 .119-.381.56.56 0 0 0-.21-.357.66.66 0 0 0-.791 0 .97.97 0 0 0-.407.668 1.6 1.6 0 0 0 .381 1.289 1.02 1.02 0 0 0 .839.341 3 3 0 0 0 .347-.047",
    "data-name": "Path 16547"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.86 49.119a1.3 1.3 0 0 1-.254.224 2.4 2.4 0 0 1-.841.377 4.2 4.2 0 0 1-1.367.079 11.4 11.4 0 0 1-1.641-.325 8.6 8.6 0 0 0-1.636-.279 3.5 3.5 0 0 0-1.328.187 2.4 2.4 0 0 0-.781.454c-.158.145-.228.243-.236.237a1.4 1.4 0 0 1 .214-.262 2.3 2.3 0 0 1 .783-.486 3.5 3.5 0 0 1 1.353-.208 8.3 8.3 0 0 1 1.652.275 12 12 0 0 0 1.629.33 4.2 4.2 0 0 0 1.345-.059 2.65 2.65 0 0 0 1.108-.542",
    "data-name": "Path 16548"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.396 40.882a.66.66 0 0 1 .5-.1 1.4 1.4 0 0 1 .556.256c.2.139.393.321.631.5s.456.432.731.644a2.36 2.36 0 0 0 1 .443 4.6 4.6 0 0 0 2.488-.357 24 24 0 0 1 2.392-.949 4 4 0 0 1 1.118-.159 3.2 3.2 0 0 1 .969.173 2.17 2.17 0 0 1 1.133.828 1 1 0 0 1 .109.194.7.7 0 0 1 .062.15 1 1 0 0 1 .038.129 2.6 2.6 0 0 0-.237-.455 2.18 2.18 0 0 0-1.125-.79 3.2 3.2 0 0 0-.95-.159 4 4 0 0 0-1.1.164 25 25 0 0 0-2.382.952 4.6 4.6 0 0 1-2.535.355 2.4 2.4 0 0 1-1.019-.461c-.279-.22-.5-.462-.726-.654s-.432-.372-.621-.51a1.36 1.36 0 0 0-.534-.262.8.8 0 0 0-.5.066",
    "data-name": "Path 16549"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.695 37.729a1.3 1.3 0 0 1 .039.217 1.9 1.9 0 0 1-.039.632 2.2 2.2 0 0 1-.449.895 1.92 1.92 0 0 1-1.143.66 2.16 2.16 0 0 1-1.557-.342 1.7 1.7 0 0 1-.6-.679.48.48 0 0 1 .051-.48.63.63 0 0 1 .445-.226.6.6 0 0 1 .486.161.75.75 0 0 1 .209.477 1.1 1.1 0 0 1-.442.937 2.8 2.8 0 0 1-.993.452 3.4 3.4 0 0 1-1.114.14 1.88 1.88 0 0 1-1.052-.39 1.25 1.25 0 0 1-.489-.96.98.98 0 0 1 .492-.905.9.9 0 0 1 .984.108.81.81 0 0 1 .155.919 1.25 1.25 0 0 1-.646.63 2.96 2.96 0 0 1-1.6.205 3.42 3.42 0 0 1-2.042-1.066 3 3 0 0 1-.375-.511 4 4 0 0 1-.1-.2 3.8 3.8 0 0 0 .5.686 3.42 3.42 0 0 0 2.031 1.032 2.9 2.9 0 0 0 1.559-.209 1.17 1.17 0 0 0 .607-.595.73.73 0 0 0-.139-.834.82.82 0 0 0-.894-.094.9.9 0 0 0-.446.832 1.16 1.16 0 0 0 .459.9 1.8 1.8 0 0 0 1 .371 3.3 3.3 0 0 0 1.086-.136 2.7 2.7 0 0 0 .963-.436 1.01 1.01 0 0 0 .413-.867.67.67 0 0 0-.185-.428.53.53 0 0 0-.423-.142.56.56 0 0 0-.392.2.4.4 0 0 0-.041.407 1.6 1.6 0 0 0 .57.648 2.1 2.1 0 0 0 1.511.342 1.88 1.88 0 0 0 1.117-.632 2.09 2.09 0 0 0 .485-1.714",
    "data-name": "Path 16550"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.882 42.438a.6.6 0 0 1 .107-.044q.108-.04.318-.1a1.9 1.9 0 0 1 1.212.049 1.8 1.8 0 0 1 .7.483 1.42 1.42 0 0 1 .368.9 1.327 1.327 0 0 1-1.5 1.344.97.97 0 0 1-.546-.244.57.57 0 0 1-.175-.55.83.83 0 0 1 .328-.455 1.3 1.3 0 0 1 .487-.22 1.89 1.89 0 0 1 1.717.431 1.87 1.87 0 0 1 .569 1.063 1.3 1.3 0 0 1 .006.446 3 3 0 0 0-.038-.441 1.87 1.87 0 0 0-.577-1.028 1.83 1.83 0 0 0-1.657-.4 1.3 1.3 0 0 0-.458.209.76.76 0 0 0-.3.409.48.48 0 0 0 .153.471.9.9 0 0 0 .5.221 1.25 1.25 0 0 0 1.411-1.257 1.36 1.36 0 0 0-.343-.852 1.74 1.74 0 0 0-.666-.474 1.9 1.9 0 0 0-1.182-.072c-.14.031-.247.063-.32.083a.6.6 0 0 1-.113.028",
    "data-name": "Path 16551"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.043 48.283a.45.45 0 0 0 .026-.233 1.4 1.4 0 0 0-.259-.589.88.88 0 0 0-.84-.335 8.5 8.5 0 0 1-1.2.141 1.446 1.446 0 0 1-1.381-1.487 1.14 1.14 0 0 1 .171-.643.6.6 0 0 1 .17-.173 2 2 0 0 0-.144.192 1.16 1.16 0 0 0-.139.624 1.5 1.5 0 0 0 .31.889 1.48 1.48 0 0 0 1.018.515 10 10 0 0 0 1.19-.134 1.3 1.3 0 0 1 .532.078.75.75 0 0 1 .36.3 1.4 1.4 0 0 1 .243.62.28.28 0 0 1-.059.236",
    "data-name": "Path 16552"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.054 54.301a1.1 1.1 0 0 0 .371-.1.68.68 0 0 0 .3-.312 1.1 1.1 0 0 0 .058-.58 4 4 0 0 0-.177-.7 2.1 2.1 0 0 0-.361-.737.81.81 0 0 0-.79-.291.49.49 0 0 0-.326.293.67.67 0 0 0-.005.466.77.77 0 0 0 .75.478 1.3 1.3 0 0 0 .832-.307 3.9 3.9 0 0 0 .947-1.226 3 3 0 0 0 .3-1c.025-.248.011-.387.02-.387a1.7 1.7 0 0 1 .013.39 2.9 2.9 0 0 1-.283 1.025 3.85 3.85 0 0 1-.953 1.261 1.37 1.37 0 0 1-.882.328 1 1 0 0 1-.493-.13.73.73 0 0 1-.336-.4.75.75 0 0 1 .007-.525.57.57 0 0 1 .382-.34.88.88 0 0 1 .872.32 2.1 2.1 0 0 1 .369.766 4 4 0 0 1 .169.718 1.14 1.14 0 0 1-.074.607.7.7 0 0 1-.332.321.8.8 0 0 1-.284.071.4.4 0 0 1-.1 0",
    "data-name": "Path 16553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.611 56.377a1 1 0 0 0 .21-.052.75.75 0 0 0 .382-.419 1.14 1.14 0 0 0-.039-.842c-.11-.31-.312-.624-.434-1a1.4 1.4 0 0 1-.073-.572 1.03 1.03 0 0 1 .2-.5 1.3 1.3 0 0 1 .753-.488 1.8 1.8 0 0 1 .606-.036.8.8 0 0 1 .218.044 2.6 2.6 0 0 0-.808.05 1.26 1.26 0 0 0-.7.476.96.96 0 0 0-.177.466 1.3 1.3 0 0 0 .071.538c.116.361.316.677.426 1a1.19 1.19 0 0 1 .021.892.76.76 0 0 1-.425.427.4.4 0 0 1-.222.021",
    "data-name": "Path 16554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M44.283 45.839a2.3 2.3 0 0 1 .256-.339c.172-.212.429-.512.75-.879s.707-.8 1.119-1.3q.31-.372.631-.787a5.3 5.3 0 0 0 .586-.9 4.5 4.5 0 0 0 .533-1.973 2.2 2.2 0 0 0-.562-1.528 1.8 1.8 0 0 0-.972-.542 4 4 0 0 0-.419-.032.3.3 0 0 1 .108-.024 1.3 1.3 0 0 1 .319 0 1.8 1.8 0 0 1 1.035.527 2.28 2.28 0 0 1 .62 1.6 4.5 4.5 0 0 1-.538 2.038 5.3 5.3 0 0 1-.6.916q-.326.417-.641.786c-.42.492-.814.919-1.144 1.278l-.783.849a2.6 2.6 0 0 1-.3.3",
    "data-name": "Path 16555"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M41.261 49.543a7.1 7.1 0 0 1-1.914.572 7.2 7.2 0 0 1 1.914-.572",
    "data-name": "Path 16556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M41.139 49.507c.02.036-.3.234-.611.57s-.485.668-.523.651a1.83 1.83 0 0 1 1.133-1.221",
    "data-name": "Path 16557"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M54.777 43.116a2.6 2.6 0 0 1-.314-.556 14 14 0 0 1-.59-1.422 14 14 0 0 1-.434-1.477 2.5 2.5 0 0 1-.1-.63 3.3 3.3 0 0 1 .2.6c.112.376.272.892.47 1.456s.4 1.066.548 1.428a3.3 3.3 0 0 1 .223.6",
    "data-name": "Path 16558"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M51.916 45.699a1.7 1.7 0 0 1-.356.549 3.61 3.61 0 0 1-2.84 1.223 1.7 1.7 0 0 1-.646-.118c0-.025.25.024.647.018a3.95 3.95 0 0 0 2.765-1.193c.276-.284.409-.5.43-.482",
    "data-name": "Path 16559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5baab",
    d: "M50.028 59.013s-1.871.4-2.118.2.358-.425.358-.425-.537.063-.554-.13.2-.331.2-.331Z",
    "data-name": "Path 16560"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5baab",
    d: "M47.503 55.402s2.63 1.178 2.662 1.269a6.9 6.9 0 0 1-.137 2.342c-.251.386-3.7-1.494-3.7-1.494Z",
    "data-name": "Path 16561"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d78776",
    d: "M49.447 58.578a.6.6 0 0 1-.132-.009l-.358-.046a8 8 0 0 1-1.165-.249 3.5 3.5 0 0 1-1.071-.515l-.3-.2a.6.6 0 0 1-.1-.081.6.6 0 0 1 .117.062l.307.187a3.8 3.8 0 0 0 1.067.5 10 10 0 0 0 1.155.263l.355.064a.6.6 0 0 1 .129.03",
    "data-name": "Path 16562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d78776",
    d: "M49.435 58.624a3.2 3.2 0 0 1-1.225.184c0-.016.276-.037.613-.088s.607-.112.612-.1",
    "data-name": "Path 16563"
  }))))))));
};
export default SvgProductInsigts;